import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, isNotNull,messageShow, millisecondToDate,getPlatformName,systemConfig,getZkShopName,getTaoteShopName,getTaoteId  } from '../../utils/http';
import { Input, Select, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog,Progress,Popover} from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import TableNavChange from '../../components/tableNavChange/tableNavChange';
import PlatformName from '../../components/platformName/index.jsx';
import $ from 'jquery';
import {Workbook} from 'exceljs';
import './procurementOrder.less';
import ShowModal from '../../components/showModal/index.jsx';
import { getLastSyncTime,GetPayUrlRequest,GetPayResultRequest,CancelPurchaseOrderRequest, getZhuKeReqTask,SyncOrderByIdsRequest,loadSupplierProduct,saveOrderSkuMapping,OrderTagsListRequest} from '../../utils/api';
import QRCode from 'qrcode.react';
import { MessageBox } from 'element-react/next';
import ChangeProductsModule from '../../components/changeProductsModule/index.jsx';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import ShowNotice from '../../components/showNotice/index';

class procurementOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourcePlatformSelect: [
        { value: "all", label: "货源平台", isSelect: true },
        { value: "AlibabaZhuKe", label: "1688货源", isSelect: false },
        // { value: "TaoteZhuKe", label: "淘特货源", isSelect: false },
        { value: "not_relation", label: "未关联货源", isSelect: false }
      ],
      selectSourcePlatformSelect: 'all',
      daySelect: [{ value: "7", label: "7天", isSelect: false }, { value: "15", label: "15天", isSelect: false }, { value: "30", label: "30天", isSelect: true }, { value: "60", label: "60天", isSelect: false }, { value: "90", label: "90天", isSelect: false }],
      selectDay: "30",
      orderStatus: [
        { id: 0, value: "", title: "待确认", active: true, num: 0 },
        { id: 1, value: "", title: "待付款", active: false, num: 0 },
        { id: 2, value: "", title: "待发货", active: false, num: 0 },
        { id: 3, value: "", title: "已发货", active: false, num: 0 },
        { id: 4, value: "", title: "交易完成", active: false, num: 0 },
        { id: 5, value: "", title: "交易关闭", active: false, num: 0 },
        { id: 6, value: "", title: "退款中", active: false, num: 0 },
        { id: 7, value: "", title: "忽略订单", active: false, num: 0 }
      ],
      orderStatusIndex: 0,
      isShowWarn: false,
      isLoadTouTiaoSdkJs: false,
      selectShopId: "",//当前登录的店铺id，非阿里的
      selectShopName: '',//列表显示的店铺名称
      selectPlatformType: "WxVideo",//当前登录的店铺类型
      zhukeOwnerCode: "",//主客账号的ownercode，用于生成抖音sdk时，传的
      isLoading: false,
      loadingTitle: "加载中...",


      pageSize: 10,
      current: 1,
      total: 0,
      orderBySort: "asc",
      orderProductByType: "ProductID",
      syncOrderBySelectOrderStatus: '',
      purchaseOrderList: [],//采购单列表
      notSetProductList: [],//未设置规格，查询的商品列表
      isShowCommonError: false,
      showCommonErrorMessage: '',
      refundType: "",

      selectOrderList: [],//选择的平台订单
      selectPurchaseOrderList: [],//选择的订单，对应的采购单


      isRemindOpen: 0,//提示次数
      createOrderTaskCode: { TaskCode: '', Ratio: 0 },

      // 确认采购单，有失败的列表。提示
      isShowModalByCreateOrderError: false,
      createOrderError: [],

      //检测到没有开通自动代扣，提示
      isShowModalByNotOpen: false,

      //超过30个是否提示，只针对开启批量的按钮有效。其他处理超过30个还是会提示
      isRemindThirty: true,
      openUrl: 'https://tradeconfig.1688.com/foundation/withhold_manage.htm',//开通自动代扣的跳转链接，默认赋值一个链接，会通过后台请求覆盖

      //------------------------以下是弹框----------------------------

      isShowModalBynotCategory: false,//提示是否设置规格
      notCategoryList: [],//未匹配的规格数据。
      notCategoryListQu: [],//未匹配的规格数据(去重，没有code)。

      selectProduct: null,//未匹配 --映射默认获取的商品信息
      supplierProductSkuList: [],//未匹配 --映射默认供应商sku信息

      // 批量开启时， 选择是否超过30条。提示
      isShowModalByBatchOpen: false,

      //点击开通按钮（会跳转或者复制链接）后2秒提示这个弹框，提示
      isShowModalByVerifyOpen: false,

      //获取付款方式，提示
      isShowModalBySelectPayment: false,
      showModalByPaymentPaymentMoney: 0,
      isShowAutoPayButton: false,//是否开通了自动代扣

      //获取【付款方式】错误，提示
      isShowModalBySelectPaymentError: false,
      getPaymentErrorFaildOrderList: [],
      getPaymentErrorNotWaitPayIds: [],
      getPaymentErrorPayChannelsList: [],

      isShowModalByPayUrl: false,//手动支付后，弹窗提示是否操作完成

      //获取手动支付，【付款链接】错误，提示
      isShowModalByPayUrlError: false,
      getPayUrlErrorFaildOrderList: [],
      getPayUrlErrorPayChannelsList: [],

      //自动代扣失败，提示
      isShowModalByAutoPaymentError: false,
      //自动代扣成功，提示
      isShowModalByAutoPaymentSuccess: false,
      autoPaymentSuccessPayingOrderIds: [],
      autoPaymentSuccessNotWaitPayIds: [],
      autoPaymentSuccessFaildOrderIds: [],

      //取消订单跳转后，弹出确认是否需要刷新数据
      isShowModalByCancelExamine: false,

      encryFialdDialog: false,//头条解密失败对话框
      encryErrorMessage: "",//头条解密失败消息
      encryFaildPlatformOrderId: "",//当前解密失败订单

      encryFialdDialogByZhongZhuan:false,//抖音中转地址，没有开启密文提示弹

      sysncOrderStatusTaskProgress: 100,//同步进度
      lastSyncTimeByShop: '',//最后同步时间，店铺的维度

      
      //订单规格匹配供货商规格
      matchDailogShow:false,
      matchSelectedOrder:null,
      matchSelectedSupplier:null,
      
      payModel:{
        PayUrl:'',//支付链接
        Code:'',//回传code
        ExpireTime:0,//支付授权有效期
        qrcodeShow:false,
        timespan:0,//倒计时
        OrderCodes:[]
      },

      isChangeProductsModule: false,
      selectProductId: '',
      selectedShopProductImgSrc: '',
      selectProductSkuId:'',

      tagEnum:{//订单标记集合
        KsRiskOrder:{
          tagName:"风控订单",
          tagClass:'danger_tag',
          clickContent:this.ksRiskOrderTagClickContent,
        },
        KsPriorityDeliveryr:{
          tagName:"优先发货",
          tagClass:'warning_tag',
        },
        PddShipHold:{
          tagName:"暂停发货",
          clickContent:this.pddShipHoldTagClickContent,
          tagClass:'warning_tag',
        },
        KsRemindShipmentSignTag:{
          tagName:"催发货",
          predicate: (order,tag) => { return order.SellerOrder.PlatformStatus == 'waitsellersend' },
          clickContent:(order,tag) =>{ return <div>催发货时间： {tag.TagValue}</div>},
          tagClass:'warning_tag',
        },
        OrderAddressUpdate:{
          tagName:"地址变更",
          style:{zIndex:"10000",maxWidth:"680px"},
          clickContent:this.ksAddressUpdate,
          tagClass:'warning_tag',
        },
        OrderReceiverUpdate:{
          tagName:"地址变更",
          style:{zIndex:"10000",maxWidth:"680px"},
          clickContent:this.ksAddressUpdate,
          tagClass:'warning_tag',
        },
        TouTiaoLogisticsTransitTag:{
          tagName:"偏远中转",
          style:{zIndex:"10000",maxWidth:"680px"},
          clickContent:this.orderLogisticsTransit,
          tagClass:'warning_tag',
        },
        TouTiaoRemoteDerictTag:{
          tagName:"偏远直邮",
          style:{zIndex:"10000",maxWidth:"680px"},
          tagClass:'warning_tag',
        }
      },
      purchaseTagEnum:{
        OrderAddressUpdate:{
          tagName:"地址变更",
          style:{zIndex:"10000",maxWidth:"600px"},
          tagClass:'warning_tag',
        },
        OrderReceiverUpdate:{
          tagName:"地址变更",
          style:{zIndex:"10000",maxWidth:"680px"},
          tagClass:'warning_tag',
        }
      },

      allOrderPayChangeAddressDialog:false,
      orderPayChangeAddressDialog:false,//订单变更地址支付对话框
      allOrderSendChangeAddressDialog:false,
      orderSendChangeAddressDialog:false,//订单变更地址发货对话框
    };
  }
  componentDidMount() {
     //拼多多的导出标签，加载时，隐藏
     $("#exportByRightId").css({ display: "none" });

    var zhukeToken = getToken();
    var that = this;
    if (zhukeToken != "")
      that.loadData();
    else {

      setTimeout(() => {
        var zhukeTokenTwo = getToken();
        if (zhukeTokenTwo == "") {
          var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
          //var hasZhukeLoginShopTokens = "";//测试。
          if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
            loadZhuKeToken(hasZhukeLoginShopTokens);

            setTimeout(() => {
              var zhukeTokenThree = getToken();
              if (zhukeTokenThree != "")
                that.loadData();
              else
                that.setState({ isShowWarn: true });

            }, 500);
          } else
            that.setState({ isShowWarn: true });
        } else
          that.loadData();
      }, 500);

    }
    // if(systemConfig.isZk1() == false && systemConfig.isZk5() == false)
    // {
    //   this.state.selectSourcePlatformSelect = '';
    // }
  }

  changeLeftNav = (name) => {
    this.props.history.replace(name)
  }
  loadData = () => {
    var shopInfo = getLoginShopInfo();
    var that = this;
    this.setState({
      selectShopId: shopInfo.loginShopId,
      selectShopName: shopInfo.loginShopName,
      selectPlatformType: shopInfo.loginShopPlatformType,
    }, () => {
      that.queryButton();
      that.syncOrderByStatus();
    })

  }


  //#region 查询 （折叠）

  loadList = () => {
    if (this.state.isShowWarn) {
      Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
      return;
    }

    this.loadTouTiaoSdkJs();

    let obj = this.loadOrderData();
    //console.log(JSON.stringify(obj));

    this.setState({ isLoading: true, loadingTitle: "加载中...", });
    let that = this;
    requests({
      url: "/PurchaseOrder/List",
      data: obj,
      success: function (res) {
        that.setState({ isLoading: false });
        var orderStatusList = that.state.orderStatus;
        if (res.Success) {
          var orderList = res.Data.Orders;
          var totals = res.Data.TotalCount;
          that.loadOrderTags(res.Data.Orders,obj.ShopId);
          var tempOrders = res.Data.Orders || [];
          if (tempOrders.length == 0)
            that.setState({ isNotList: true });
          else
            that.setState({ isNotList: false });

          if (orderList == null || orderList == undefined)
            orderList = [];

          var orderStatusIndex = that.state.orderStatusIndex;
          for (let i = 0; i < orderList.length; i++) {
            orderList[i].ShopName = that.state.selectShopName;
            orderList[i].SellerOrder.LastShipTimeValue = "";

            if (isNotNull(orderList[i].SellerOrder.LastShipTime) && (orderStatusIndex == 0 || orderStatusIndex == 1 || orderStatusIndex == 2)) {
              var nowTime = new Date().getTime();
              var LastTime = new Date(orderList[i].SellerOrder.LastShipTime).getTime();
              var LastShipTime = LastTime - nowTime;

              if (LastShipTime < 43200000)//小于12小时都标红色
                orderList[i].SellerOrder.LastShipTimeIsRed = true;

              if (LastShipTime > 0)
                orderList[i].SellerOrder.LastShipTimeValue = millisecondToDate(LastShipTime);
              else {
                orderList[i].SellerOrder.LastShipTimeValue = "已超时 " + millisecondToDate(-LastShipTime);
                orderList[i].SellerOrder.LastShipTimeIsEnd = true;
              }


            }

          }

          for (var i = 0; i < orderStatusList.length; i++) {
            if (orderStatusList[i].active == true) {
              orderStatusList[i].num = totals;
              break;
            }
          }

          that.setState({ purchaseOrderList: orderList, total: totals, orderStatus: orderStatusList });

          that.orderListCheckboxClose();
        } else {
          Message({
            showClose: true,
            message: res.Message,
            type: 'error'
          });
        }
      },
      fail: (err) => { }
    });
  }

  //获取列表，拼接请求数据
  loadOrderData() {
    let obj = {};
    obj.ShopId = this.state.selectShopId;
    //var orderStatusList = this.state.orderStatus;
    var indexs = this.state.orderStatusIndex;
    // for (let i = 0; i < orderStatusList.length; i++) {
    //   if (orderStatusList[i].active == true) {
    //     indexs = orderStatusList[i].id;
    //     break;
    //   }
    // }

    var syncOrderStatus = this.state.syncOrderBySelectOrderStatus;
    if (syncOrderStatus != "") {
      obj.OrderStatus = syncOrderStatus;
      if (obj.OrderStatus == "waitpurchase" || obj.OrderStatus == "waitbuyerpay" || obj.OrderStatus == "waitsellersend")
        obj.OrderSubState = this.state.orderSubstate;
    }
    else if (indexs == 0)//待确认
    {
      //obj.PurchaseOrderStatus = "waitpurchase";
      obj.OrderStatus = "waitpurchase";
      obj.OrderSubState = this.state.orderSubstate;
    } else if (indexs == 1)//待付款
    {
      //obj.PurchaseOrderStatus = "waitbuyerpay";
      obj.OrderStatus = "waitbuyerpay";
      obj.OrderSubState = this.state.orderSubstate;
    } else if (indexs == 2)//待发货
    {
      //obj.PurchaseOrderStatus = "waitsellersend";
      obj.OrderStatus = "waitsellersend";
      obj.OrderSubState = this.state.orderSubstate;
    } else if (indexs == 3)//已发货
    {
      //obj.PurchaseOrderStatus = "";
      obj.OrderStatus = "waitbuyerreceive";
    } else if (indexs == 4)//交易完成
    {
      //obj.PurchaseOrderStatus = "";
      obj.OrderStatus = "success";
    } else if (indexs == 5)//交易关闭
    {
      if (this.state.refundType == "noRefund")
        obj.OrderStatus = "purchase_no_refund";
      else if (this.state.refundType == "refund")
        obj.OrderStatus = "purchase_refund";
      else
        obj.OrderStatus = "cancel";
    } else if (indexs == 6)//退款中
    {
      //obj.PurchaseOrderStatus = "";
      obj.OrderStatus = "wait_seller_agree";
      //obj.RefundStatus = "WAIT_SELLER_AGREE";
    } else if (indexs == 7)//忽略订单
    {
      obj.OrderStatus = "ignore";
    }
    obj.SourcePlatform = this.state.selectSourcePlatformSelect;


    //var dayas="7";
    // var chooseDate=this.state.chooseDate;//天数
    // for (let i = 0; i < chooseDate.length; i++) {
    //   if(chooseDate[i].isSelect == true)
    //      dayas= chooseDate[i].value;
    // }

    // var dayas = $("#selectChooseDateId").val();


    var orderId = $("#orderListInputOrderId").val();
    if (orderId != "" && orderId != undefined && orderId != null)
      obj.PurchaseOrderStatus = "";
    else {
      var orderProductByType = this.state.orderProductByType;
      if (orderProductByType == "ProductID")
        obj.ProductID = $("#orderProductByTypeInputeId").val();//商品id
      else
        obj.ProductSubject = $("#orderProductByTypeInputeId").val();//商品标题

      obj.SupplierWangWang = $("#supplierWangWangInputId").val();//供应商旺旺
    }

    obj.Days = this.state.selectDay;
    obj.OrderBy = this.state.orderBySort;
    obj.PlatformOrderId = orderId;
    obj.PageIndex = this.state.current;
    obj.PageSize = this.state.pageSize;
    obj.PlatformType = this.state.selectPlatformType;
    obj.SystemVersions = "pc";

    return obj;
  }


  queryButton = (isQuery) => {
    if (isQuery) {  //为true 时为搜索调用  current恢复第1页
      this.setState({ current: 1 }, () => {
        this.loadList();
      })
    } else {     //为切换页码时调用
      this.loadList();
    }

  }

  loadTouTiaoSdkJs = () => {
    var platformType = this.state.selectPlatformType;
    var isLoadTouTiaoSdkJs = this.state.isLoadTouTiaoSdkJs;
    if (platformType == "TouTiao" && isLoadTouTiaoSdkJs == false) {
      try {
        const script = document.createElement("script");
        script.src = "https://lf3-open-web-sdk.bytetos.com/obj/open/sdk_v2.js";
        script.async = true;
        document.body.appendChild(script);

        setTimeout(() => {
          try{
            const appkey = '6925303336539309583';//头条应用的appkey
            const ownerCode = this.state.zhukeOwnerCode;
            window.BYTES_OPEN_int({
              accountId: ownerCode,  // 服务商账号体系中的用户唯一id，每个ISV下需要保证唯一，可选格式：1）独立生成的账户唯一标识     
              appKey: appkey,         // 应用创建完成后被分配的key     
              sensUrls: [               // 配置会访问open侧敏感信息的url-path       
                "/PurchaseOrder/CreateOrder.*"         // 可以写完整的url-path，如果url中包含参数，参数部分可以用正则表达式'.*'       
              ],
            })
          }catch(ee){
            console.log("初始化头条sdk错误22：" + ee);
          }
         
        }, 2000);

        this.setState({ isLoadTouTiaoSdkJs: true });
      } catch (e) {
        console.log("初始化头条sdk错误：" + e);
      }
    }
  }


  changeCurrent = (current) => {
    this.setState({
      current,
      checkAll: false
    }, () => {
      this.queryButton();
    })
  }
  changePageSize = (size) => {
    this.setState({
      pageSize: size,
      current: 1,
    }, () => {
      this.queryButton();
    })
  }

  //切换时间
  changeSelect = (name, value) => {
    this.setState({
      [name]: value
    })
  }
  onChangeInput = (name, value) => {
    let obj = {};
    obj[name] = value.trim();
    this.setState(obj);
  }


  //订单状态切换
  changeNav = (item) => {
    if (item.title == "交易关闭") {
      $("#searchWarn").css({ display: "flex" })
    } else {
      $("#searchWarn").css({ display: "none" })
    }


    if (item.title == "待确认" || item.title == "待付款" || item.title == "待发货") {
      $("#waitingSendExportId").css({ display: "flex" });
    } else
      $("#waitingSendExportId").css({ display: "none" });

    if (item.title == "待确认")
      $("#mergeOrderByLeftId").css({ display: "flex" });
    else
      $("#mergeOrderByLeftId").css({ display: "none" });

    var selectShopPlatformType = this.state.selectPlatformType;
    if (item.title == "待发货" && selectShopPlatformType !="Pinduoduo" )
      $("#sendErrorByLeftId").css({ display: "flex" });
    else
      $("#sendErrorByLeftId").css({ display: "none" });

    if (item.title == "待发货" && selectShopPlatformType == "Pinduoduo")//目前只放给拼多多，后续其他的平台发货受平台限制，在加条件
      $("#exportByRightId").css({ display: "flex" });
    else
      $("#exportByRightId").css({ display: "none" });


    this.substateCheckboxEmpty();//清空子状态勾选


    var orderStatus = this.state.orderStatus;
    for (var i = 0; i < orderStatus.length; i++) {
      if (orderStatus[i].id == item.id)
        orderStatus[i].active = true;
      else
        orderStatus[i].active = false;
    }
    this.setState({ orderStatus: orderStatus, orderStatusIndex: item.id, refundType: "", orderSubstate: "" }, () => {
      this.queryButton(true);
    })
  }

   //#endregion

  //订单编号输入框，输入后，其他的输入框就不会有效。
  orderInputOnClick = () => {
    var orderId = $("#orderListInputOrderId").val();
    if (orderId != "" && orderId != null && orderId != undefined) {
      $("#supplierWangWangInputId").attr("disabled", "disabled");
      $("#orderProductByTypeInputeId").attr("disabled", "disabled");
    } else {
      $("#supplierWangWangInputId").removeAttr('disabled');
      $("#orderProductByTypeInputeId").removeAttr('disabled');
    }
  }


  //确认采购订单--按钮
  confirmOrder = (orderCode) => {
    var orderList = this.state.purchaseOrderList;
    var selectOrderList = [];
    if (orderCode == null || orderCode == undefined || orderCode == "")
      selectOrderList = this.state.selectOrderList;
    else
      selectOrderList.push(orderCode);


    if (selectOrderList.length == 0) {
      messageShow("请选择订单!", "warning");
      return;
    }

    var notCategoryList = [];
    var notCategoryListTitle = "";
    var notCategoryListTitleNumber = 0;
    for (let i = 0; i < orderList.length; i++) {
      for (let j = 0; j < selectOrderList.length; j++) {
        if (orderList[i].SellerOrder.OrderCode == selectOrderList[j]) {
          var orderItemList = orderList[i].SellerOrder.OrderItems;
          for (let k = 0; k < orderItemList.length; k++) {
            if (orderItemList[k].IsFenXiao == true && orderItemList[k].IsMapping == false)//临时注释，为了有数据做跳转，这个验证需要有
            //if (orderItemList[k].IsFenXiao == true)//临时注释，为了有数据做跳转，这个验证需要有
            {
              var listJson = {
                ShopId: orderItemList[k].ShopId,
                ProductID: orderItemList[k].ProductID,
                SupplierProductId: orderItemList[k].SupplierProductId,
                SupplierProductCode: orderItemList[k].SupplierProductCode,
              }
              notCategoryList.push({ orderCode: orderList[i].SellerOrder.OrderCode, ListJson: listJson });
              if (notCategoryListTitleNumber == 3)
                notCategoryListTitle += "...";
              if (notCategoryListTitleNumber < 3)
                notCategoryListTitle += orderItemList[k].ProductSubject + "；";

              notCategoryListTitleNumber++;
            }
          }
        }
      }
    }

    const notRelateOrders = orderList.filter(s => selectOrderList.includes(s.SellerOrder.OrderCode)).filter(s => !s.BuyerOrders || s.BuyerOrders.length == 0);
    if(notRelateOrders.length > 0){

      MessageBox.alert("所选订单有商品未关联货源，请先关联货源并匹配规格后再下单!")
      return;
    }

    if (notCategoryList.length > 0) {
      this.setState({ notCategoryList: notCategoryList, notCategoryListTitle: notCategoryListTitle, isShowModalBynotCategory: true });
      return;
    }

    this.setState({ selectOrderList: selectOrderList }, () => {
      this.createPurchaseOrder();
    });


    var data = {
      OrderCodeList: this.state.selectOrderList,
      ShopId: this.state.selectShopId
    }

  }


  //批量忽略订单--按钮
  ignoreOrder = (ignoreType, orderCode) => {

    var selectOrderList = [];
    if (orderCode == null || orderCode == undefined || orderCode == "")
      selectOrderList = this.state.selectOrderList;
    else
      selectOrderList.push(orderCode);

    if (selectOrderList.length == 0) {
      messageShow("请选择订单!", "warning");
      return;
    }

    var data = {
      IgnoreOrderCodes: selectOrderList,
      IgnoreType: ignoreType,
      ShopId: this.state.selectShopId
    }

    this.setState({ isLoading: true, loadingTitle: '处理中...', selectOrderList: selectOrderList });
    var that = this;
    requests({
      url: "/PurchaseOrder/BatchIgnoreOrder",
      data: data,
      success: (res) => {
        that.setState({ isLoading: false });
        if (res.Success) {
          if (ignoreType == 1)
            messageShow("忽略采购单成功。", "success");
          else
            messageShow("已取消忽略采购单。", "success");

          that.succeedOrderCodeList();
        } else
          messageShow("错误信息：" + res.Message, "error");
      },
      fail: (err) => { }
    })

  }


  //处理完成后，需要列表移除的调用这个方法
  succeedOrderCodeList = (platformOrderIdOrCode) => {
    var selectList = [];
    if (platformOrderIdOrCode != null && platformOrderIdOrCode != "" && platformOrderIdOrCode != undefined)
      selectList.push(platformOrderIdOrCode);
    else
      selectList = this.state.selectOrderList;

    var orderList = this.state.purchaseOrderList;
    var newOrderList = [];
    for (let i = 0; i < orderList.length; i++) {
      var isE = false;
      for (let j = 0; j < selectList.length; j++) {
        //订单code或者订单编号
        if (orderList[i].SellerOrder.OrderCode == selectList[j] || orderList[i].SellerOrder.PlatformOrderId == selectList[j])
          isE = true;
      }

      if (!isE)//不存在
        newOrderList.push(orderList[i]);
    }


    this.orderListCheckboxClose();//清楚勾选

    //刷新页面
    if (newOrderList.length == 0)
      this.loadList();
    else {
      var orderStatus = this.state.orderStatus;
      for (let i = 0; i < orderStatus.length; i++) {
        if (orderStatus[i].active == true) {
          var number = orderStatus[i].num;
          orderStatus[i].num = number - (orderList.length - newOrderList.length);
          break;
        }
      }

      this.setState({
        purchaseOrderList: newOrderList,
        selectOrderList: [],
        selectPurchaseOrderList: [],
        orderStatus: orderStatus
      });//从页面中移除
    }

  }

  //清除勾选
  orderListCheckboxClose = () => {
    $("#orderList_table tr input[type=checkbox]").prop('checked', false);


    $("#allCheck_id_Below").prop("checked", false);//下面的按钮点击
    $("#allCheck_id_Above").prop("checked", false);//上面的按钮点击

    this.setState({ selectOrderList: [] });
  }


  //临时更换产品规格
  changeTemporaryRelation = (purchaseOrder, sellerOrderItem) => {
    var data = {
      ShopId: purchaseOrder.SellerOrder.ShopId,
      ProductId: sellerOrderItem.ProductID,
      IsTemporarySearch: true,
      PlatformOrderId: purchaseOrder.SellerOrder.PlatformOrderId
    };
    this.setState({
      isLoading: true, loadingTitle: '获取信息中...',
      tempPlatformOrderId: purchaseOrder.SellerOrder.PlatformOrderId,
      tempOrderCode: purchaseOrder.SellerOrder.OrderCode,
      tempOrderItemCode: sellerOrderItem.OrderItemCode
    });
    var that = this;

    requests({
      url: "/Product/LoadProductSkuMapping",
      data: data,
      success: (res) => {
        that.setState({ isLoading: false });
        if (res.Success) {
          var skuList = res.Data.AlibabaProductSku;
          var product = res.Data.ProductFx;
          var supplierProductSkuList = [];
          var tempSkuList = [];

          for (let i = 0; i < product.Skus.length; i++) {
            if (product.Skus[i].SkuId == sellerOrderItem.SkuID) {
              tempSkuList.push(product.Skus[i]);
            }
          }

          product.Skus = tempSkuList;

          for (let i = 0; i < product.Skus.length; i++) {
            //如果发现后台返回值的mappingcount为0，改为1
            if (product.Skus[i].SupplierSkuList != null) {
              for (let n = 0; n < product.Skus[i].SupplierSkuList.length; n++) {
                if (product.Skus[i].SupplierSkuList[n].MappingCount == null || product.Skus[i].SupplierSkuList[n].MappingCount == 0) {
                  product.Skus[i].SupplierSkuList[n].MappingCount = 1;
                }
              }
            } else if (product.Skus[i].SupplierSkuId != null && product.Skus[i].SupplierSkuId > 0) {
              product.Skus[i].SupplierSkuList = [];
              product.Skus[i].SupplierSkuList.push({
                SupplierSkuId: product.Skus[i].SupplierSkuId,
                SupplierSkuName: product.Skus[i].SupplierSkuName,
                MappingCount: 1
              });
            }
          }

          if (skuList.length > 0) {
            for (let i = 0; i < skuList.length; i++) {
              supplierProductSkuList.push({
                label: skuList[i].Color + skuList[i].Size,
                value: skuList[i].SkuId
              });
            }
          }

          that.setState({
            isShowTempRelevanceProduct: true,//显示关联商品页面
            TempSelectProduct: product,
            TempSelectSupplierLoginId: res.Data.SupplierLoginId,
            TempSelectSupplierProductId: res.Data.SupplierProductId,
            TempSelectSupplierSourcePlatform: res.Data.SourcePlatform,
            TempSupplierProductSkuList: supplierProductSkuList,
            TempSelectPlatformTypeRelevance: purchaseOrder.SellerOrder.PlatformType
          });
        } else {
          messageShow("错误信息：" + res.Message, "error");
        }
      },
      fail: (err) => { }
    })

  }


  closeTempRelevanceProduct = () => {
    this.setState({
      isShowTempRelevanceProduct: false,//显示关联商品页面
      TempSelectProduct: null,
      TempSelectSupplierLoginId: '',
      TempSelectSupplierProductId: '',
      TempSupplierProductSkuList: '',
      TempSelectPlatformTypeRelevance: '',
    })
  }



  //下拉  选中事件
  selectTempSupplierProduct = (e, skuId, index) => {
    var tarEle = e.target;
    if (tarEle.value != "") {
      $(tarEle).addClass("active")
    } else {
      $(tarEle).removeClass("active")
    }
    var supplierSkuId = e.target.parentNode.childNodes[0].selectedOptions[0].value;
    var supplierSkuName = e.target.parentNode.childNodes[0].selectedOptions[0].text;
    var mappingCount = e.target.parentNode.childNodes[1].value;

    if (mappingCount != null && mappingCount != '') {
      if (!(/(^[1-9]\d*$)/.test(mappingCount))) {
        e.target.parentNode.childNodes[1].value = 1;
        messageShow("数量必须填正整数的！", "warning");
        return false;
      }
    }

    var selectProduct = this.state.TempSelectProduct;
    var skuList = selectProduct.Skus;
    //商品
    for (let i = 0; i < skuList.length; i++) {
      if (skuId == skuList[i].SkuId) {
        if (skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList.length == 0) {
          skuList[i].SupplierSkuList = [];
          skuList[i].SupplierSkuList.push({
            SupplierSkuId: supplierSkuId,
            SupplierSkuName: supplierSkuName,
            MappingCount: 1
          });
        }
        else {
          for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
            if (skuList[i].SupplierSkuList[n].SupplierSkuId == supplierSkuId && n != index) {
              messageShow("该供应商规格在组合中已存在！", "warning");
              e.target.selectedIndex = 0;
              skuList[i].SupplierSkuList.splice(index, 1);
              return false;
            }
          }

          skuList[i].SupplierSkuList[index].SupplierSkuId = supplierSkuId;
          skuList[i].SupplierSkuList[index].SupplierSkuName = supplierSkuName;
          skuList[i].SupplierSkuList[index].MappingCount = mappingCount;

          if (supplierSkuId == undefined || supplierSkuId == null || supplierSkuId == '') {
            messageShow("规格不能选择空，当前选择是无效的！", "warning");
            return false;
          }
        }
      }
    }
    selectProduct.Skus = skuList;

    this.setState({ TempSelectProduct: selectProduct })
  }

  //规格型号 添加规格(临时更换货源)
  addTempSupplierProductSku = (e, skuId) => {
    var selectProduct = this.state.TempSelectProduct;
    var skuList = selectProduct.Skus;
    //商品
    for (let i = 0; i < skuList.length; i++) {
      if (skuId == skuList[i].SkuId) {
        if (skuList[i].SupplierSkuList == null) {
          skuList[i].SupplierSkuList = [];
          skuList[i].SupplierSkuList.push({
            SupplierSkuId: '',
            SupplierSkuName: '',
            MappingCount: 1
          });
        }

        skuList[i].SupplierSkuList.push({
          SupplierSkuId: '',
          SupplierSkuName: '',
          MappingCount: 1
        });
      }
    }
    selectProduct.Skus = skuList;

    this.setState({ TempSelectProduct: selectProduct })
  }

  //规格型号 删除规格(临时更换货源)
  deleteTempSupplierProductSku = (e, skuId, index) => {
    var selectProduct = this.state.TempSelectProduct;
    var skuList = selectProduct.Skus;

    for (let i = 0; i < skuList.length; i++) {
      if (skuList[i].SkuId == skuId) {
        skuList[i].SupplierSkuList.splice(index, 1);
      }
    }

    selectProduct.Skus = skuList;
    this.setState({ TempSelectProduct: selectProduct })
  }

    //确认关联操作，保存(临时更换货源)
    sureTempRelevanceRequest = (isSomething) => {
      var selectProduct = this.state.TempSelectProduct;
      var selectSupplierLoginId = this.state.TempSelectSupplierLoginId;
      var selectSupplierProductId = this.state.TempSelectSupplierProductId;
      var selectSourcePlatform = this.state.TempSelectSupplierSourcePlatform;
      var selectShopPlatformType = this.state.TempSelectPlatformTypeRelevance;
      var tempPlatformOrderId = this.state.tempPlatformOrderId;
      var tempOrderCode = this.state.tempOrderCode;
      var tempOrderItemCode = this.state.tempOrderItemCode;

    var skuMappingList = [];
    var skuList = selectProduct.Skus;

    for (let i = 0; i < skuList.length; i++) {
      if (skuList[i].SupplierSkuList == undefined || skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList[0].SupplierSkuId == "") {
        continue;
      }

      for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
        if (skuList[i].SupplierSkuList[n].SupplierSkuId == undefined || skuList[i].SupplierSkuList[n].SupplierSkuId == null ||
          skuList[i].SupplierSkuList[n].SupplierSkuId == "" || skuList[i].SupplierSkuList[n].MappingCount <= 0) {
          continue;
        }

        skuMappingList.push({
          SkuId: skuList[i].SkuId,
          SupplierSkuId: skuList[i].SupplierSkuList[n].SupplierSkuId,
          MappingCount: skuList[i].SupplierSkuList[n].MappingCount,
          PlatformOrderId: tempPlatformOrderId,
          OrderCode: tempOrderCode,
          OrderItemCode: tempOrderItemCode
        });
      }
    }

      //判断
      if (skuMappingList.length <= 0) {
        messageShow("供应商规不能全部为空","warning");
        return false;
      }

    var dataJson = {
      SupplierProductId: selectSupplierProductId,
      SourcePlatform: selectSourcePlatform,
      SupplierMemberId: '',
      SupplierLoginId: selectSupplierLoginId,
      ProductId: selectProduct.PlatformId,
      TargetShopId: selectProduct.ShopId,
      SkuMappings: skuMappingList,
      TargetShopPt: selectShopPlatformType,
    }

    this.setState({
      isLoading: true,
      isShowTempRelevanceProduct: false,
      isShowChangeProduct: false
    });


    var that = this;

    requests({
      url: "/PurchaseOrder/RelateTemporaryProduct",
      data: dataJson,
      success: (res) => {
        that.setState({ isLoading: false });
        if (res.Success) {
          messageShow("重新映射成功。", "success");
          that.UpdateSingleOrder();
        } else {
          messageShow("重新映射失败：" + res.Message, "error");
        }
      },
      fail: (err) => { }
    })

  }

 //局部更新单个订单
 UpdateSingleOrder = (productId) => {
  var shopid = this.state.selectShopId;
  let obj = this.loadOrderData(shopid);
  obj.PlatformOrderId = this.state.tempPlatformOrderId;

  var that = this;
  var shopName = this.state.selectShopName;;
  requests({
      url: "/PurchaseOrder/GetSingleOrder",
      data: obj,
      success: (res) => {
          that.setState({ isLoading: false });
          if (res.Success) {
              var orderList = that.state.purchaseOrderList;
              var productID = productId || that.state.TempSelectProduct.PlatformId;
              var orderStatusIndex=that.state.orderStatusIndex;
              res.Data.ShopName = shopName;
              res.Data.SellerOrder.LastShipTimeValue="";

              if (isNotNull(res.Data.SellerOrder.LastShipTime) && (orderStatusIndex == 0 || orderStatusIndex == 1 || orderStatusIndex == 2))  {
                var nowTime = new Date().getTime();
                var LastTime = new Date(res.Data.SellerOrder.LastShipTime).getTime();
                var LastShipTime = LastTime - nowTime;

                if (LastShipTime < 43200000)//小于12小时都标红色
                res.Data.SellerOrder.LastShipTimeIsRed = true;

                if (LastShipTime > 0)
                res.Data.SellerOrder.LastShipTimeValue = millisecondToDate(LastShipTime);
                else
                {
                  res.Data.SellerOrder.LastShipTimeValue ="已超时 " + millisecondToDate(-LastShipTime);
                  res.Data.SellerOrder.LastShipTimeIsEnd=true;
                }
              }

              for(let n = 0; n < orderList.length; n++) {
                if(orderList[n].SellerOrder.PlatformOrderId == that.state.tempPlatformOrderId && orderList[n].SellerOrder.OrderItems[0].ProductID == productID){
                  orderList[n] = res.Data;
                }
              }

              that.setState({ purchaseOrderList: orderList });
          } else {
              messageShow("局部更新订单失败：" + res.Message, 'error');
          }
      }
  });
}

  //==============================请求后台接口=========================================

  //确认采购单  --请求接口
  createPurchaseOrder() {
    var data = {
      OrderCodeList: this.state.selectOrderList,
      ShopId: this.state.selectShopId
    }

    this.setState({ isLoading: true, loadingTitle: '处理中...' });
    var that = this;

    requests({
      url: "/PurchaseOrder/CreateOrder",
      data: data,
      success: (res) => {
        if (res.Success) {
          var taskCode = res.Data;
          var createOrderTaskCode = { TaskCode: taskCode, Ratio: 0 };
          that.setState({ createOrderTaskCode: createOrderTaskCode });

          setTimeout(() => {
            that.createOrderTask();
          }, 1000);
        }
        else {
          messageShow("错误信息：" + res.Message, "error");
          that.setState({ isLoading: false });
        }
      },
      fail: (err) => {
        messageShow("请求异常（确认采购单）", "error");
        that.setState({ isLoading: false });
      }
    })

  }


  createOrderTask = () => {

    var createOrderTaskCode = this.state.createOrderTaskCode;
    var taskCode = createOrderTaskCode.TaskCode;

    var that = this;
    requests({
      url: "/Common/GetZhuKeReqTask",
      data: { TaskCode: taskCode },
      success: (res) => {
        if (res.Success) {
          var dates = res.Data;
          if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
            that.setState({ isLoading: false, createOrderTaskCode: { TaskCode: '', Ratio: 0 } });
            var selectShopPlatformType = this.state.selectPlatformType;
            if (dates.Status == "Error" && dates.ErrorMsg != null && dates.ErrorMsg != undefined && dates.ErrorMsg != "") {
              if (selectShopPlatformType == 'TouTiao'
                && (dates.ErrorMsg.includes('请停止非必要的解密，12小时内自动回复') || dates.ErrorMsg.includes('额度') || dates.ErrorMsg.includes('环境安全风险'))) {
                that.setState({ encryFialdDialog: true, encryErrorMessage: dates.ErrorMsg });
              }
              else if (selectShopPlatformType == 'KuaiShou' && (dates.ErrorMsg.includes('额度') || dates.ErrorMsg.includes('解密'))) {
                that.setState({ encryFialdDialog: true, encryErrorMessage: dates.ErrorMsg });
              }
              else if(selectShopPlatformType == 'TouTiao' && (dates.ErrorMsg.includes('中转订单') && dates.ErrorMsg.includes('密文')))
              {
                that.setState({ encryFialdDialogByZhongZhuan: true,encryErrorMessage : dates.ErrorMsg});
              }
              else {
                that.setState({ isShowCommonError: true, showCommonErrorMessage: dates.ErrorMsg });//统一用弹窗
              }
            }
            else if (dates.Status == "Error" && dates.RspContent == null) {
              messageShow("确认采购单任务已处理，失败原因:RspConten is null", "error");

            } else {
              var rspContentJson = JSON.parse(dates.RspContent);
              var list = rspContentJson.DataList;
              var isOpen = rspContentJson.IsOpen;
              if (list == null || list == undefined)
                list = [];

              var errorList = [];//全部成功
              for (let i = 0; i < list.length; i++) {
                var resJson = list[i];
                if (resJson.IsSuccess == false)
                  errorList.push(resJson);
              }

              //优先显示错误列表，其次再显示  自动代扣的检测
              if (errorList.length > 0) {
                that.setState({ isShowModalByCreateOrderError: true, createOrderError: errorList });
                return;
              }

              //成功后，从列表中移除,不管有没有开通
              that.succeedOrderCodeList();
              messageShow("采购单创建成功。", "success");

              //没有错误的列表(errorList) ，没有开通自动代扣(isOpen),没有点击【不再提醒】
              // if (errorList.length == 0 && isOpen == false && that.state.isRemindOpen < 8)
              //   that.setState({ isShowModalByNotOpen: true, isRemindOpen: that.state.isRemindOpen + 1 });

            }
          } else {
            //任务未执行完，继续轮训
            setTimeout(() => {
              that.createOrderTask();
            }, 1000);
          }
        } else {
          that.setState({ isShowCommonError: true, showCommonErrorMessage: res.Message });

          that.setState({ isLoading: false, createOrderTaskCode: { TaskCode: '', Ratio: 0 } });
        }
      },
      fail: (err) => {
        messageShow("请求异常（确认采购单）", "error");
        that.setState({ isLoading: false });
      }
    })

  }

  //采购单支付请求
  orderPayment = (orderCode,confirm) => {
    var selectOrderList = [];
    if (orderCode == null || orderCode == undefined || orderCode == "")
      selectOrderList = this.state.selectOrderList;
    else
      selectOrderList.push(orderCode);


    if (selectOrderList.length == 0) {
      messageShow("请选择订单", "warning");
      return;
    }

    var buyerCodeList = this.getListPurchaseOrderCode(selectOrderList, true);
    if(buyerCodeList.length > 0)
    {
      var orderList = this.state.purchaseOrderList.map(x => x.BuyerOrders).flat().filter(x => x && x.BuyerOrder && x.BuyerOrder.OrderTags);

      let findChangeAddressOrders = [];
      for (let index = 0; index < buyerCodeList.length; index++) {
        const buyerCode = buyerCodeList[index];
        const item = orderList.find(x => x.BuyerOrder.OrderCode == buyerCode);
        if(!item) continue;
        
        let changeAddressTag = item.BuyerOrder.OrderTags.find(x => x.Tag == 'OrderAddressUpdate' || x.Tag == 'OrderReceiverUpdate');
        if(changeAddressTag)
          findChangeAddressOrders.push(buyerCode);
      }

      if(findChangeAddressOrders.length > 0 && findChangeAddressOrders.length == buyerCodeList.length && !confirm)
      {
        this.setState({ 'allOrderPayChangeAddressDialog':true})
        return;
      }
      else if(findChangeAddressOrders.length > 0 && !confirm)
      {
        this.setState({ 'orderPayChangeAddressDialog':true})
        return;
      }
      buyerCodeList = buyerCodeList.filter(x => !findChangeAddressOrders.includes(x))
    }
    var buyerOrders = this.state.purchaseOrderList.map(s => s.BuyerOrders.map(x => x.BuyerOrder)).flat().filter(x => x)
    buyerOrders = buyerOrders.filter(x => buyerCodeList.includes(x.OrderCode))

    const hasAlibabaOrder = buyerOrders.findIndex(x => x.PlatformType == "AlibabaZhuKe") > -1
    const hasTaoteOrder = buyerOrders.findIndex(x => x.PlatformType == "TaoteZhuKe") > -1

    if(hasAlibabaOrder && hasTaoteOrder){
      messageShow('多个采购平台订单无法一起支付! 请选择采购平台后分别支付!','info');
      return;
    }
    if (buyerCodeList.length == 0) {
      messageShow("选择的订单没有待付款的采购单！","warning");
      return;
    }
    if(hasTaoteOrder && selectOrderList.length > 40){
      messageShow("淘特批量手动付款最多只支持一次40笔，请减少数量","warning");
      return;
    }
    if(hasTaoteOrder)
    {
      this.taotePayUrl(buyerCodeList);
      return;
    }
    this.setState({ selectOrderList: selectOrderList, selectPurchaseOrderList: buyerCodeList });
    if (buyerCodeList.length > 30 && this.state.isRemindThirty) {
      this.setState({ isShowModalByBatchOpen: true });
      return;
    }

    if (buyerCodeList.length == 0) {
      messageShow("选择的订单没有待付款的采购单！", "warning");
      return;
    }

    if (buyerCodeList.length > 30) {
      this.protocalPayOpenConfirm(true);
    } else {
      setTimeout(() => {
        this.getOrderPayType();
      }, 0);
    }
  }

  //淘特支付
  async taotePayUrl(orderCodes)
  {
    this.setState({ isLoading: true, loadingTitle: '获取支付二维码中...' });
    const data = {  OrderCodes : orderCodes}
    const res = await GetPayUrlRequest(data);
    this.setState({ isLoading: false, loadingTitle: '' });
    if(!res.Success){
      messageShow("获取支付二维码异常：" + res.Message,'error')
      return;
    }
    if(!res.Data && res.Data.PayUrlMap && res.Data.PayUrlMap['TaoteZhuKe'])
    {
      messageShow("获取支付二维码",'error')
      return;
    }
    const payModel = res.Data.PayUrlMap['TaoteZhuKe'];
    this.state.payModel.PayUrl = payModel.PayUrl
    this.state.payModel.Code = payModel.Code
    this.state.payModel.ExpireTime = payModel.ExpireTime
    this.state.payModel.qrcodeShow = true;
    this.state.payModel.OrderCodes = orderCodes;
    this.setState({ },()=>{
      var authTimeSpan = (payModel.ExpireTime - new Date().valueOf() - 1000) / 1000 ;
      authTimeSpan = Math.floor(authTimeSpan);
      
      this.qrCountDown(authTimeSpan);
      setTimeout(()=>{
        this.getPayReusltPoll();
      },3000)
    })
  }
  //关闭支付二维码
  closeQrCodeInfo(){
    this.state.payModel.PayUrl = ''
    this.state.payModel.Code = ''
    this.state.payModel.ExpireTime = ''
    this.state.payModel.qrcodeShow = false;
    this.setState({ })
  }
  //二维码有效期倒计时
  qrCountDown(timespan)
  {
    $("#authTimespan").text(timespan);
    this.state.payModel.timespan = timespan
    if(timespan == 0 || !this.state.payModel.PayUrl){
      this.closeQrCodeInfo();return;
    }
    this.setState({ })
    timespan = timespan - 1;
    setTimeout(()=>{ this.qrCountDown(timespan); },1000)
  }
  //
  async getPayReusltPoll()
  {
    if(this.state.payModel.qrcodeShow == false || this.state.payModel.timespan < 1)
      return

    const data = {
      OrderCodes : this.state.payModel.OrderCodes,
      Code : this.state.payModel.Code
    }
    var res = await GetPayResultRequest(data);
    if(res.Success){
      if(res.Data.PaySuccess == true)
      {
        this.closeQrCodeInfo();
        messageShow('支付成功','success');
        this.state.orderStatusIndex = 2;
        const orderStatus = this.state.orderStatus.find(x => x.title == "待发货")
        this.setState({})
        setTimeout(()=>{ this.changeNav(orderStatus)},2500)
      }
      else if(res.Data.PayFail == true)
      {
        this.closeQrCodeInfo();
        messageShow('支付失败','info');
      }
      else if(res.Data.PayStatus == 'process' || res.Data.PayStatus == 'init')
      {
        setTimeout(()=>{ this.getPayReusltPoll() },2000);
      }else
      {
        messageShow('支付失败','error');
        this.closeQrCodeInfo();
      }
    }else
    {
      setTimeout(()=>{ this.getPayReusltPoll() },1500);
    }
  }
  //订单详情页面（官方）
  async orderDetailLink(buyerOrder, isInspect, buyerPlatformOrderId, buyerPlatformOrderCode, sellerOrderId){
    let orderId = buyerOrder.PlatformOrderId;
    if(buyerOrder && buyerOrder.PlatformType == "TaoteZhuKe")
    {
      if (isInspect == true) {
        var that = this;
        setTimeout(() => {
          that.setState({
            isShowModalByCancelExamine: true,
            buyerPlatformOrder: buyerOrder,
            buyerPlatformOrderId: buyerPlatformOrderId,
            buyerPlatformOrderCode: buyerPlatformOrderCode,
            detailsPlatformOrderId: sellerOrderId
          });
        }, 1000);
      }
      var taoteurl = 'https://trade.taobao.com/trade/detail/trade_order_detail.htm?biz_order_id='+orderId;
      window.open(taoteurl);
      return;
    }else if(buyerOrder && buyerOrder.IsPifatuan == true && isInspect == true){
      this.cancelPurchaseOrder(buyerPlatformOrderCode);
      return;
    }

    if (isInspect == true) {
      var that = this;
      setTimeout(() => {
        that.setState({
          isShowModalByCancelExamine: true,
          buyerPlatformOrderId: buyerPlatformOrderId,
          buyerPlatformOrder: buyerOrder,
          buyerPlatformOrderCode: buyerPlatformOrderCode,
          detailsPlatformOrderId: sellerOrderId
        });
      }, 1000);
    }
    var url = "https://trade.1688.com/order/new_step_order_detail.htm?orderId=" + orderId;

    window.open(url);
  }
  async cancelPurchaseOrder(orderCode)
  {
    this.setState({isLoading:true});
    const data = { OrderCodes:[orderCode] }
    const res = await CancelPurchaseOrderRequest(data);
    if(!res.Success){
      messageShow('服务异常：'+res.Message,'error');
      return;
    }
    const taskCode = res.Data;
    setTimeout(()=>{ this.zhukeReqTaskPoll(taskCode); },1000)
  }
  async zhukeReqTaskPoll(taskCode){
    var res = await getZhuKeReqTask({TaskCode :taskCode});
    if (res.Success) {
      var dates = res.Data;
      if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
        this.setState({ isLoading: false, createOrderTaskCode: { TaskCode: '', Ratio: 0 } });
        if (dates.Status == "Error" && dates.ErrorMsg != null && dates.ErrorMsg != undefined && dates.ErrorMsg != "")
        {
          messageShow(dates.ErrorMsg,"error");
        }
        else if (dates.Status == "Error" && dates.RspContent == null) 
        {
          messageShow("取消订单失败:RspConten is null","error");
        } else {
          if(dates.RspContent){
            const rspContent = JSON.parse(dates.RspContent);
            var failResult =rspContent.filter(s => s.Success == false);
            var successResult =rspContent.filter(s => s.Success == true);
            if(failResult.length > 0)
            {
              MessageBox.alert(<div>
                <p>有订单取消失败：</p>
                {
                  failResult.map(s => {
                    return <p>订单：{s.PurchaseOrderId}，原因：{s.ErrorMessage}</p>
                  })
                }
              </div>)
            }else{
              messageShow("取消订单成功","success");
            }
            this.loadList()
          }else{
            messageShow("取消订单成功","success");
          }
          
        }
      } else {
        //任务未执行完，继续轮训
        setTimeout(() => {
          this.zhukeReqTaskPoll(taskCode);
        }, 1000);
      }
    } else {
      this.setState({isShowCommonError:true,showCommonErrorMessage:res.Message});
      this.setState({ isLoading: false, createOrderTaskCode: { TaskCode: '', Ratio: 0 } });
    }
  }
  async syncSingleOrder(item){
    if(!item || !item.PlatformOrderId) return;
    const data={ PlatformOrderIds: item.PlatformOrderId, ShopId:item.ShopId }
    await SyncOrderByIdsRequest(data);
  }
  //============================请求后台接口 end =======================



  //平台订单商品列表页面
  renderSellerOrderTr = (item, itemSellerSkuList, index, sellerOrderLength) => {
    return (
      <tr style={{ padding: "1px 5px" }} className={index > 1 ? "hideTr tr" + index : "tr" + index}>
        <td style={{ width: "360px" }}>
          <div class="productShow">
            <div class="productShow-imgWrap">
              <img src={itemSellerSkuList.ProductImgUrl}
                alt="" />

              {itemSellerSkuList.IsFenXiao == false ?
                <span class="product-status">未分销</span>
                : null
              }
              {itemSellerSkuList.IsFenXiao == true && itemSellerSkuList.RefundStatus != "" && itemSellerSkuList.RefundStatus != null && itemSellerSkuList.RefundStatus != "REFUND_SUCCESS" && itemSellerSkuList.RefundStatus != "REFUND_CLOSE" ?
                <span class="product-status warnBackColor">退款中</span>
                : null
              }
              {itemSellerSkuList.IsFenXiao == true && itemSellerSkuList.RefundStatus != "" && itemSellerSkuList.RefundStatus != null && itemSellerSkuList.RefundStatus == "REFUND_SUCCESS" ?
                <span class="product-status warnBackColor">退款完成</span>
                : null
              }
              {itemSellerSkuList.IsFenXiao == true && (itemSellerSkuList.RefundStatus == "" || itemSellerSkuList.RefundStatus == null || itemSellerSkuList.RefundStatus == 'REFUND_CLOSE')
                && itemSellerSkuList.Status == "waitbuyerreceive" ?
                <span class="product-status">已发货</span>
                : null
              }

            </div>
            <ul>
              <li title="商品标题">{itemSellerSkuList.ProductSubject}</li>
              <li>
                <span>商家规格:</span>
                <span class="spgg mainColor">{itemSellerSkuList.Color}{itemSellerSkuList.Size}</span>

                {
                  itemSellerSkuList.tag && itemSellerSkuList.tag['KsGiftTag'] ? 
                  <span className={'danger_tag'} style={{marginLeft:"4px",padding:'1px'}}>赠品</span>:null
                }
                
              </li>
              {
                itemSellerSkuList.IsFenXiao == true && itemSellerSkuList.IsMapping == false ?
                  <li>
                    <span class="order-seller-skuStats-orange">规格未匹配</span>
                    <span class="defColor hover" onClick={() => { this.matchSkuClick(itemSellerSkuList, item) }}> 去匹配</span>
                  </li>
                  : null
              }
              {
                itemSellerSkuList.IsFenXiao == true && itemSellerSkuList.IsSendFaild == true ?
                  <li style={{marginTop:'5px'}}>
                    <span class="order-seller-skuStats-red" >自动发货失败，请手动重新发货</span>
                    <span onClick={() => this.onlineSendErrorMsg(item.SellerOrder.PlatformOrderId, itemSellerSkuList.OrderItemCode)} className="dangerColor hover">查看原因</span>
                  </li>
                  : null
              }
              {
                itemSellerSkuList.IsFenXiao == true && this.state.orderStatusIndex == 0 && itemSellerSkuList.IsMapping == true ?
                  <li style={{ display:'flex',gap:'8px'}}>
                    {/* <span class="defColor hover" onClick={() => this.changeTemporaryRelation(item, itemSellerSkuList)}>更换规格</span> */}

                    <span class="defColor hover" onClick={() => this.relevanceProduct(itemSellerSkuList, 2,item)}>更换规格</span>
                    <span class="defColor hover" onClick={() => this.relevanceProduct(itemSellerSkuList, 1,item)}>替换货源</span>
                    
                  </li>
                  : null
              }
            </ul>
            <div class="productNum mainColor">
              <span>￥{itemSellerSkuList.ItemAmount}</span>
              <span>x{itemSellerSkuList.Count}</span>
            </div>
          </div>
        </td>
        {
          index == 0 ?
            <td rowspan={sellerOrderLength > 1 ? 2 : sellerOrderLength} style={{ textAlign: "center" }} className="hebin">
              <div style={{ marginBottom: "8px" }}>
                <span class="mainColor">{item.SellerOrder.ProductCount}种商品共计{item.SellerOrder.ProductItemCount}件</span>
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span>金额:(含运费:￥{item.SellerOrder.ShippingFee}) ￥{item.SellerOrder.TotalAmount}</span>
              </div>
              {
                this.state.orderStatusIndex == 0 ?
                  <div>
                    {
                      <span class="defColor hover" onClick={() => this.ignoreOrder(1, item.SellerOrder.OrderCode)}>忽略订单 </span>
                    }
                    <span class="defColor hover" onClick={() => this.confirmOrder(item.SellerOrder.OrderCode)}>确认采购单</span>
                  </div> : null
              }
              {
                this.state.orderStatusIndex == 7 ?
                  <div>
                    {
                      <span class="defColor hover" onClick={() => this.ignoreOrder(0, item.SellerOrder.OrderCode)}>取消忽略</span>
                    }
                  </div> : null
              }
            </td> : null
        }
      </tr>
    )
  }

  // 采购订单信息页面
  renderBuyerOrderTr = (itemBuyList, itemBuySkuList, index, itemBuySkuListLength, item) => {
    return (
      <tr style={{ padding: "1px 5px" }} className={index > 1 ? "hideTr tr" + index : "tr" + index}>
        <td style={{ width: "360px" }}>
          <div class="productShow">
            <div class="productShow-imgWrap">
              <img src={itemBuySkuList.ProductImgUrl}
                alt="" />
              {
                itemBuySkuList.RefundStatus != "" && itemBuySkuList.RefundStatus != null && itemBuySkuList.RefundStatus != "REFUND_SUCCESS" ?
                  <span className="product-status" style={{ backgroundColor: "#fe6f4f" }}>退款中</span> : null
              }
              {
                itemBuySkuList.RefundStatus != "" && itemBuySkuList.RefundStatus != null && itemBuySkuList.RefundStatus == "REFUND_SUCCESS" ?
                  <span className="product-status" style={{ backgroundColor: "#fe6f4f" }}>退款完成</span> : null
              }
              {
                (itemBuySkuList.RefundStatus == "" || itemBuySkuList.RefundStatus == null) && itemBuySkuList.Status == "waitbuyerreceive" ?
                  <span className="product-status" style={{ backgroundColor: "#3aadff" }}>已发货</span> : null
              }
            </div>
            <ul>
              <li title="商品标题">
                {itemBuySkuList.ProductSubject}
                {
                  itemBuyList.BuyerOrder.PlatformType == "TaoteZhuKe" ?
                    <Tag type='warning'>淘特</Tag>:null
                }
                {
                  itemBuyList.BuyerOrder.PlatformType == "AlibabaZhuKe" ?
                  <Tag type='warning'>1688</Tag>:null
                }
              </li>
              <li>
                <span>商家规格:</span>
                <span class="spgg mainColor">{itemBuySkuList.Color} {itemBuySkuList.Size}</span>
              </li>
            </ul>
            <div class="productNum mainColor">
              <span>￥{itemBuySkuList.ItemAmount}</span>
              <span>x{itemBuySkuList.Count}</span>
            </div>
          </div>
        </td>

        {index == 0 ?
          <td rowspan={itemBuySkuListLength > 1 ? 2 : itemBuySkuListLength} style={{ textAlign: "center" }} className="hebin">
            {
              itemBuyList.BuyerOrder != null ?
                <div style={{ marginBottom: "8px", display: "flex", flexDirection: "column" }}>
                  <span class="mainColor" style={{ marginBottom: "8px" }}>{itemBuyList.BuyerOrder.ProductCount}种商品共计{itemBuyList.BuyerOrder.ProductItemCount}件</span>
                  {itemBuyList.BuyerOrder.TotalAmount != null ? <span>金额:(含运费:￥{itemBuyList.BuyerOrder.ShippingFee}) ￥{itemBuyList.BuyerOrder.TotalAmount}</span> : null}
                </div>
                : null
            }
            <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>

              {
                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus != "" ?
                  <div style={{ marginRight: "5px" }} onClick={() => this.orderDetailLink(itemBuyList.BuyerOrder)}>
                    <span className="defColor hover">订单详情</span>
                  </div> : null
              }

              {
                itemBuyList.BuyerOrder != null && itemBuyList.IsSendFaild == true ?
                  <div style={{ marginRight: "5px" }} onClick={() => this.reOnlineSend(item.SellerOrder.OrderCode, item.SellerOrder.PlatformOrderId, itemBuyList.BuyerOrder.OrderCode, itemBuyList.BuyerOrder.PlatformOrderId,itemBuyList.BuyerOrder)}>
                    <span className="dangerColor hover">重新发货</span>
                  </div> : null
              }
              {
                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus == "waitbuyerpay" ?
                  <div style={{ marginRight: "5px" }} onClick={() => this.orderDetailLink(itemBuyList.BuyerOrder, true, itemBuyList.BuyerOrder.PlatformOrderId, itemBuyList.BuyerOrder.OrderCode, item.SellerOrder.PlatformOrderId)}>
                    <span className="dangerColor hover">取消订单</span>
                  </div> : null
              }

              {/* {
                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus == "cancel" ?
                  <div style={{ marginRight: "5px" }} onClick={() => this.anewCreateOrder(item.SellerOrder.OrderCode, itemBuyList.BuyerOrder.OrderCode)}>
                    <span className="dangerColor hover">重新采购</span>
                  </div> : null
              } */}

              {
                itemBuyList.BuyerOrder.PlatformType != "TaoteZhuKe" && itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus == "waitbuyerpay" ?
                  <div >
                    <span className="defColor hover" onClick={() => this.orderPayment(item.SellerOrder.OrderCode)}>向供应商付款</span>
                  </div> : null
              }
              {
                itemBuyList.BuyerOrder.PlatformType == "TaoteZhuKe" && itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus == "waitbuyerpay" ?
                  <div >
                    <span className="defColor hover" onClick={() => this.orderDetailLink(itemBuyList.BuyerOrder)}>向供应商付款</span>
                  </div> : null
              }
            </div>
          </td> : null
        }
      </tr>

    )
  }


  moreShowProduct(e, len) {
    let eleName = e.target.nodeName.toUpperCase();
    let ele = null;
    if (eleName == "SPAN") {
      ele = $(e.target);
    } else {
      ele = $(e.target).closest("span");
    }
    if (ele.hasClass("moreTrShow")) {
      ele.removeClass("moreTrShow").closest("tr").prevAll(".hideTr").css({ display: "none" });
      ele.find("s").text("展开更多");
      ele.closest("tr").prevAll(".tr0").find(".hebin").attr("rowspan", 2);
    } else {
      ele.addClass("moreTrShow").closest("tr").prevAll(".hideTr").css({ display: "table-row" });
      ele.find("s").text("收起商品");
      ele.closest("tr").prevAll(".tr0").find(".hebin").attr("rowspan", len);

    }
  }

  //已取消  --点击确认
  cancelExamineShowModalByConfirm = () => {
    this.setState({ isShowModalByCancelExamine: false, isLoading: true });
    //this.loadList();
    this.syncOneOrder("buyer", "cancelButton");
  }
  //同步订单后，再查一次。商品详情页面
  syncOneOrder = (orderType, operation) => {
    var buyerPlatformOrderId = this.state.buyerPlatformOrderId;//平台订id
    var buyerPlatformOrder = this.state.buyerPlatformOrder;//平台订id
    var buyerPlatformOrderCode = this.state.buyerPlatformOrderCode;//平台订单code
    var detailsPlatformOrderId = this.state.detailsPlatformOrderId;//采购单
    var data = { PlatformOrderIds: '', ShopId: '', PurchaseOrderCode: '', PurchaseOrderId: '' };
    var url = "";
    if (orderType == "buyer") {
      data.ShopId = buyerPlatformOrder.ShopId;
      data.PurchaseOrderId = buyerPlatformOrderId;
      data.PurchaseOrderCode = buyerPlatformOrderCode;
      url = "/PurchaseOrder/CancelPurchaseOrderConfirm"
    } else {
      data.PlatformOrderIds = detailsPlatformOrderId;
      data.ShopId = this.state.selectShopId;
      url = "/Order/SyncSingleOrder";
    }
    this.setState({ isLoading: true, loadingTitle: '检测订单...' });
    var that = this;
    requests({
      url: url,
      data: data,
      success: function (res) {

        //关闭动画
        that.setState({ isLoading: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;

        if (res.Success) {
          var list = res.Data;
          if (list != null && list.length > 0) {
            var order = list[0];
            //说明取消成功，重新查询，（取消成功后会变成待确认）
            if (operation == "cancelButton") {
              if (order.PlatformStatus == "cancel") {
                messageShow("取消成功，准备刷新页面", "success");
                setTimeout(() => {
                  that.orderStatusChangeNav(0);
                }, 1000);
              } else
                messageShow("订单没有取消成功！", "info");
            }

            //重新发货的操作
            if (operation == "reOnlineSendButton") {
              //发货成功后，触发查询按钮即可，不触发切换的导航栏
              if (order.PlatformStatus == "waitbuyerreceive") {
                $("#queryOrderButton").click();
              }
            }

          }

        } else
          messageShow("错误信息：" + res.Message,'error');
      },
    });
  }
  orderStatusChangeNav(id) {
    var orderStatus = this.state.orderStatus;
    var item = null;
    for (var i = 0; i < orderStatus.length; i++) {
      if (orderStatus[i].id == id) {
        orderStatus[i].active = true;
        item = orderStatus[i];
      } else {
        orderStatus[i].active = false;
      }
    }
    this.substateCheckboxEmpty();//清空子状态勾选

    this.setState({
      orderStatus: orderStatus,
      orderStatusIndex: id,
      refundType: "",
      orderSubstate: ""
    }, () => {
      this.changeNav(item);//触发切换导航事件
    })
  }


  //单选事件
  orderChange = (e, sellerOrderCode) => {
    var isChecked = $("#" + sellerOrderCode + "_Id").prop("checked");

    var list = this.state.purchaseOrderList;
    var selectOrderList = this.state.selectOrderList;

    //当前选中订单
    const selectOrder = list.find(o => o.SellerOrder.OrderCode == sellerOrderCode);
    if (selectOrder && selectOrder.SellerOrder.IsRisk == true) {
      messageShow("选择的订单中包含平台风控订单，默认不选中；（平台标记去除前不支持处理此类订单）！", "warning");

      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
      return;
    }
    if(selectOrder && selectOrder.SellerOrder.IsOrderLogisticsTransitTag == true)
    {
      messageShow("选择的订单中包含了中转订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
      return;
    }

    var isRefund = false;
    for (let i = 0; i < list.length; i++) {
      if (list[i].SellerOrder.OrderCode == sellerOrderCode) {
        if (list[i].SellerOrder.RefundStatus != null && list[i].SellerOrder.RefundStatus != "" && list[i].SellerOrder.RefundStatus != "REFUND_CLOSE")
          isRefund = true;

        break;
      }
    }


    let isHas = false; //是否已经存在了
    for (let j = 0; j < selectOrderList.length; j++) {
      if (selectOrderList[j] == sellerOrderCode) {
        selectOrderList.splice(j, 1);
        isHas = true;  //点之前已经存在了
      }
    }


    //待发货状态下 正常未发货的商品不选中
    let normal = false;
    if (this.state.orderStatusIndex == 2) {
      let order = list.find(o => o.SellerOrder.OrderCode == sellerOrderCode);
      if (order) {
        //没有发货失败且没有退款
        if (order.SellerOrder.OrderItems.find(item => item.IsSendFaild == false) && isRefund == false) {
          normal = true;
        }
      }
      if (!isHas && isRefund == false && normal == false) {
        selectOrderList.push(sellerOrderCode);
      }
    } else if (!isHas && isRefund == false) {//codeId 之前没有存在的，添加进去  //&& isRefund==false 临时
      selectOrderList.push(sellerOrderCode);
    }

    if (isChecked && isRefund) {
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
    } else if (this.state.orderStatusIndex == 2 && normal == true && isChecked) {
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
    }

    //去掉单选时，全选默认去掉
    if (!isChecked) {
      $("#allCheck_id_Below").prop("checked", false);//上面的按钮点击，下面的全选跟着变化
      $("#allCheck_id_Above").prop("checked", false);//下面的按钮点击，上面的全选跟着变化
    } else {
      if (selectOrderList.length == list.length) {
        $("#allCheck_id_Below").prop("checked", true);//上面的按钮点击，下面的全选跟着变化
        $("#allCheck_id_Above").prop("checked", true);//下面的按钮点击，上面的全选跟着变化
      }

    }

    var buyerCodeList = this.getListPurchaseOrderCode(selectOrderList, false);
    if (isRefund && isChecked)
      messageShow('选中的商品包含了退款,批量操作会过滤，请到订单【右边的按钮】!', "warning");
    else if (normal && this.state.orderStatusIndex == 2 && isChecked)
      messageShow('当前订单对应的采购单还未发货，不支持手动发货!', "warning");
    else {
      if (buyerCodeList.length > 30)
        messageShow('已选择超过30条，手动支付会限制。', "warning");
    }


    this.setState({ selectOrderList: selectOrderList, purchaseOrderList: list, selectPurchaseOrderList: buyerCodeList });


  }


  //全部，选择商品事件
  allCheckbox(types) {
    var isCheck = false;

    if (types == "above")
      isCheck = $("#allCheck_id_Above").prop("checked");//上面的按钮
    else
      isCheck = $("#allCheck_id_Below").prop("checked");//下面的按钮


    var selectOrderList = this.state.selectOrderList;
    var list = this.state.purchaseOrderList;
    var isRefundNumber = 0;
    var isRiskOrderCount = 0;
    var isOrderLogisticsTransitCount = 0;
    if (!isCheck)  //取消全选  选中的selectOrderList 置空
    {
      selectOrderList = [];
      for (let i = 0; i < list.length; i++) {
        $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
      }
    } else {
      for (let i = 0; i < list.length; i++) {
        //退款的不选中
        if (list[i].SellerOrder.RefundStatus != "" && list[i].SellerOrder.RefundStatus != null && list[i].SellerOrder.RefundStatus != "REFUND_CLOSE")
          isRefundNumber++;
        else if (list[i].SellerOrder.IsRisk == true) {
          isRiskOrderCount++;
        }
        else  if(list[i].SellerOrder.IsOrderLogisticsTransitTag==true)//中转地址
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isOrderLogisticsTransitCount++;
        }
        else {
          if (this.state.orderStatusIndex == 2 && list[i].SellerOrder.OrderItems.filter(item => item.IsSendFaild).length == 0)//待发货下只选择发货失败的
          {
            var len = list[i].SellerOrder.OrderItems.filter(item => item.IsSendFaild).length;
            if (len > 0) {
              selectOrderList.push(list[i].SellerOrder.OrderCode);
            } else {
              $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
            }
          } else {
            selectOrderList.push(list[i].SellerOrder.OrderCode);
            $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", isCheck);
          }
        }
      }
      selectOrderList = [...new Set(selectOrderList)];//数组去重
    }

    var titles = "全选的订单中,有" + isRefundNumber + "个订单包含退款，不默认选中，请单选！";
    if (isRefundNumber > 0)
      messageShow(titles, "warning");
    else if (isRiskOrderCount > 0)
      messageShow("选择的订单中包含平台风控订单，默认不选中；（平台标记去除前不支持处理此类订单）", "warning");
    else if(isOrderLogisticsTransitCount>0)
      messageShow("选择的订单中包含了中转订单，默认不选中，请确认后点击【确认采购单】单独进行下单", "warning");


    var buyerIdList = this.getListPurchaseOrderCode(selectOrderList, false);

    this.setState({ selectOrderList: selectOrderList, purchaseOrderList: list, isAllChange: isCheck, selectPurchaseOrderList: buyerIdList });

    $("#allCheck_id_Below").prop("checked", isCheck);//上面的按钮点击，下面的全选跟着变化
    $("#allCheck_id_Above").prop("checked", isCheck);//下面的按钮点击，上面的全选跟着变化
  }


  //获取采购单  订单Code数组List
  getListPurchaseOrderCode(selectOrderList, isFiltrPany) {
    var orderList = this.state.purchaseOrderList;

    var idList = [];
    if (selectOrderList == null || selectOrderList == undefined)
      idList = this.state.selectOrderList;
    else
      idList = selectOrderList;

    var purchaseOrderIdList = [];
    for (let i = 0; i < orderList.length; i++) {

      for (let j = 0; j < idList.length; j++) {
        if (idList[j] == orderList[i].SellerOrder.OrderCode) {
          var buyerOrdersList = orderList[i].BuyerOrders;
          for (let k = 0; k < buyerOrdersList.length; k++) {
            if (buyerOrdersList[k].BuyerOrder != null) {
              if (isFiltrPany && buyerOrdersList[k].BuyerOrder.ExtField1 != "Success"
                && buyerOrdersList[k].BuyerOrder.ExtField1 != "Paying"
                && buyerOrdersList[k].BuyerOrder.PlatformStatus == "waitbuyerpay")
                purchaseOrderIdList.push(buyerOrdersList[k].BuyerOrder.OrderCode)
            }
          }
          break;
        }
      }
    }

    return purchaseOrderIdList;
  }


  //未匹配规格，弹框操作--确认按钮
  notCategoryByShowModalByOk = () => {
    this.setState({});//关闭提示操作的弹框

    var lists = this.state.notCategoryList;
    var listJsons = [];
    for (let i = 0; i < lists.length; i++) {
      var jsons = lists[i].ListJson;

      //去重
      var isE = false;
      for (let j = 0; j < listJsons.length; j++) {
        if (jsons.ProductID == listJsons[j].ProductID
          && jsons.SupplierProductCode == listJsons[j].SupplierProductCode)
          isE = true;
      }
      if (isE == false)
        listJsons.push(lists[i].ListJson);
    }

    var notCategoryListQu = [];

    this.setState({
      isShowModalBynotCategory: false,
      notCategoryListQu: notCategoryListQu
    });


    //不判断数量，统一弹框
    this.showProductMapping();

    this.relevanceProductList(listJsons);

  }
  syncOrder() {
    // this.setState({  //开启加载动画
    //   isSyncLoading: true
    // })
    var shopId = this.state.selectShopId;
    if (!shopId) {
      return;
    }
    var shopByLists = [];
    shopByLists.push(shopId);
    var data = {
      FromSyncBtn:true,
      SyncSids: shopByLists
    }

    this.setState({ sysncOrderStatusTaskProgress: 0 });
    var that = this;
    requests({
      url: "/Order/TriggerSync",
      data: data,
      success: function (res) {
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
          that.setState({ isSyncLoading: false });
          that.setState({ sysncOrderStatusTaskProgress: 0 });
          return;
        }

        if (res.Success) {
          that.syncOrderByStatus();

          //   setTimeout(() => {
          //     that.setState({
          //       isSyncLoading: false
          //     })
          //   }, 3000)
        } else {
          messageShow("同步错误：" + res.Message, "error");
          that.setState({ isSyncLoading: false });
          that.setState({ sysncOrderStatusTaskProgress: 0 });
        }
      },
    });

    //开发时删除 模拟调接口 成功了关闭加载动画
    // setTimeout(() => {
    //     this.setState({
    //         isSyncLoading: false
    //     })
    // }, 5000)

  }
  syncOrderByStatus = () => {

    var shopid = this.state.selectShopId;
    var platformType = this.state.selectPlatformType;

    if (!shopid)
      return;
    var sid_pt = [];
    sid_pt.push({ Key: shopid, Value: platformType });


    var that = this;
    requests({
      url: "/Order/GetSyncStatus",
      data: { Sid_PlatformType: sid_pt },
      success: function (res) {
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
          that.setState({ isSyncLoading: false });
          that.setState({ sysncOrderStatusTaskProgress: 100 });
          return;
        }

        if (res.Success) {
          if (res.Data == 100) {
            that.setState({ sysncOrderStatusTaskProgress: res.Data });
            that.shopLastSyncTime(shopid, platformType);
          } else {
            that.setState({ sysncOrderStatusTaskProgress: res.Data });

            setTimeout(() => {
              that.syncOrderByStatus();
            }, 1000);
          }


        } else {
          that.setState({ sysncOrderStatusTaskProgress: 100 });
        }

      },
    });

  }

  //获取最后同步的时间
  shopLastSyncTime(shopId, platformType) {
    var obj = {
      ShopIds: [shopId],
      SyncType: 1,
      PlatformType: platformType
    }
    var that = this;
    getLastSyncTime(obj).then(res => {
      if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        return;

      if (res.Success) {
        var lastSyncTime = res.Data;
        that.setState({ lastSyncTimeByShop: lastSyncTime });
      } else {
        messageShow("获取最后同步时间，错误信息：" + res.Message, "error");
      }
    });
  }

  //未设置规格，  显示规格列表
  relevanceProductList = (listJsons) => {

    var list = [];


    var productIdList = listJsons;
    for (let i = 0; i < productIdList.length; i++) {
      var product = productIdList[i];
      list.push({
        ShopId: this.state.selectShopId,
        ProductId: product.ProductID,
        SupplierProductId: product.SupplierProductId,
        SupplierProductCode: product.SupplierProductCode
      })
    }

    var selectShopPlatformType = this.state.selectPlatformType;

    //变成查询，是会查询平台和供应商映射信息
    this.setState({ isLoading: true, loadingTitle: '显示规格列表' });
    var that = this;

    requests({
      url: "/Product/LoadProductListByMapping",
      data: { ProductMappingList: list, ShopPt: selectShopPlatformType },
      success: (res) => {
        if (res.Success) {
          var list = res.Data.DataList;
          if (list == null || list == undefined)
            list = [];


          //默认选择第一个。
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i == 0) {
                list[i].IsShow = true;
                var shopId = list[i].Product.ShopId;
                var platformId = list[i].Product.PlatformId;
                setTimeout(() => {
                  that.relevanceProducShowButt(shopId, platformId);
                }, 500);
              } else
                list[i].IsShow = false;
            }

            that.setState({ notSetProductList: list });
          }

        } else {
          messageShow("获取规格错误：" + res.Message, "error");
          that.setState({ isLoading: false });
        }
      },
      fail: (err) => { }
    })

  }


  //未设置规格，  显示规格详情信息
  relevanceProducShowButt = (shopId, productId) => {

    var data = {
      ShopId: shopId,
      ProductId: productId
    };

    //变成查询，是会查询平台和供应商映射信息
    // this.setState({ isLoading: true,loadingTitle:'获取规格详情...'});
    this.setState({ isShowProductMappingOnload: true, loadingTitle: '获取规格详情...' });

    var that = this;

    requests({
      url: "/Product/LoadProductSkuMapping",
      data: data,
      success: (res) => {
        that.setState({ isShowProductMappingOnload: false, isLoading: false });
        if (res.Success) {
          var skuList = res.Data.AlibabaProductSku;
          var product = res.Data.ProductFx;

          var supplierProductSkuList = [];

          var selectOrderList = that.state.selectOrderList;
          var purcharseOrderList = that.state.purchaseOrderList;
          var skuIds = [];
          for (let i = 0; i < selectOrderList.length; i++) {

            let order = purcharseOrderList.find(s => s.SellerOrder.OrderCode == selectOrderList[i]);
            if (order && order.SellerOrder.OrderItems && order.SellerOrder.OrderItems.length > 0) {
              skuIds.push(...order.SellerOrder.OrderItems.map(s => s.SkuID));
            }
          }

          if (skuList.length > 0) {
            for (let i = 0; i < skuList.length; i++) {
              supplierProductSkuList.push({
                label: skuList[i].Color + skuList[i].Size,
                value: skuList[i].SkuId
              });
            }
          }

          var notDisplaySkuList = [];
          for (let i = 0; i < product.Skus.length; i++) {
            if (product.Skus[i].SupplierSkuList != null && product.Skus[i].SupplierSkuList.length > 0) {
              notDisplaySkuList.push(product.Skus[i].SkuId);

              //如果发现后台返回值的mappingcount为0，改为1
              for (let n = 0; n < product.Skus[i].SupplierSkuList.length; n++) {
                if (product.Skus[i].SupplierSkuList[n].MappingCount == null || product.Skus[i].SupplierSkuList[n].MappingCount == 0) {
                  product.Skus[i].SupplierSkuList[n].MappingCount = 1;
                }
              }
            } 
            // else if (product.Skus[i].SupplierSkuId != null) {
            //   notDisplaySkuList.push(product.Skus[i].SkuId);
            // }
            // else if (!skuIds.includes(product.Skus[i].SkuId)) {
            //   notDisplaySkuList.push(product.Skus[i].SkuId);
            // }
          }

          that.setState({
            //isShowRelevanceProduct:true,//显示关联商品页面
            selectProduct: product,
            notDisplaySkuList: notDisplaySkuList,
            supplierLoginId: res.Data.SupplierLoginId,
            supplierProductId: res.Data.SupplierProductId,
            //supplierProduct:supplierProduct,
            selectSourcePlatform: res.Data.SourcePlatform,
            supplierProductSkuList: supplierProductSkuList
          });
        } else {
          messageShow("获取规格错误：" + res.Message, "error");
          that.setState({ isLoading: false });
        }
      },
      fail: (err) => { }
    })

  }


  //未设置规格列表，选择商品 
  selectNotSetProduct = (platformId) => {

    var notSetProductList = this.state.notSetProductList;
    var that = this;
    for (let i = 0; i < notSetProductList.length; i++) {
      if (notSetProductList[i].Product.PlatformId == platformId) {
        notSetProductList[i].IsShow = true;

        //清空右边sku数据，重新查询渲染
        that.setState({ selectProduct: null, supplierProductSkuList: [] });

        var shopId = notSetProductList[i].Product.ShopId;
        var platformId = notSetProductList[i].Product.PlatformId;
        setTimeout(() => {
          that.relevanceProducShowButt(shopId, platformId);
        }, 0);
      } else
        notSetProductList[i].IsShow = false;
    }

    this.setState({ notSetProductList: notSetProductList });
  }

  //未匹配规格，提示操作--关闭事件
  cancelNotCategoryByShowModal = () => {
    this.setState({ isShowModalBynotCategory: false, notCategoryList: [], notCategoryListTitle: '' });
  }

  showProductMapping = () => {
    $("#productMappingDailog").css({
      right: 0
    })
  }
  closeProductMapping = () => {
    $("#productMappingDailog").css({
      right: "-1000px"
    })
  }



  //确认采购单 遮罩弹框 new
  productMappingRender = function () {
    const { selectProduct } = this.state;
    return (
      <div className="productMappingDailog" id="productMappingDailog">
        {/* <ShowBoxLoading isShow={this.state.isShowProductMappingOnload} title={"获取规格详情..."} /> */}

        <div className="productMappingDailog-up">
          <span className="productMappingDailog-up-title">商品规格映射</span>
          <i className="iconfont icon-jia-copy1" onClick={() => this.closeProductMapping()}></i>
        </div>
        <div className="productMappingDailog-main">
          <div className="productMappingDailog-left">
            <ul className="productMappingDailog-product">
              {
                this.state.notSetProductList.map((item) =>
                  <li className={item.IsShow == true ? "active" : ""}  >
                    <div class="dailogSkuMapWrap-up-main" onClick={() => this.selectNotSetProduct(item.Product.PlatformId)}>
                      <div class="productShow table-product">
                        <div class="productShow-imgWrap">
                          <img src={item.Product.ImageUrl == null || item.Product.ImageUrl == "" ? "" : item.Product.ImageUrl} alt="" />
                          {
                            item.Product.Status == 'published' ?
                              <span className="product-status">在售中</span> : <span className="product-status" style={{ backgroundColor: "#ff511c" }}>在售中</span>
                          }

                        </div>
                        <ul>
                          <li title="商品标题">{item.Product.Subject}</li>
                          <li className="product-num">
                            <span>售价：￥{item.Product.minPrice}起</span>
                            {/* <span>库存：250</span> */}
                          </li>
                        </ul>
                      </div>
                      <div className="productShow-btns">
                        <span className="productShow-btns-btn" onClick={() => this.selectNotSetProduct(item.Product.PlatformId)}>规格映射</span>
                      </div>
                    </div>
                  </li>
                )
              }



            </ul>
          </div>
          <div className="productMappingDailog-right">
            {
              selectProduct != null ?

                <div className="productMappingDailog-right-main">
                  <div className="productMappingDailog-right-mainUp">

                    <div className="purchaseOrdersDailog-table-title" style={{ backgroundColor: "#f6f9fd" }}>
                      已关联{getPlatformName(selectProduct.PlatformType)}的商品
                    </div>
                    <div class="productShow table-product">
                      <div class="productShow-imgWrap">
                        <img src={selectProduct.ImageUrl == null || selectProduct.ImageUrl == "" ? "" : selectProduct.ImageUrl} alt="" />
                        <span className="product-status">在售中</span>
                      </div>
                      <ul>
                        <li title="商品标题">{selectProduct.Subject}</li>
                        <li className="product-num">
                          <span className="warnColor">售价：￥{selectProduct.minPrice}起</span>
                          <a className="defColor hover" target="_blank" href={"https://detail.1688.com/offer/" + this.state.supplierProductId + ".html"}>查看货源</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="productMappingDailog-right-table">
                    <table className="table-style01">
                      <thead>
                        <tr>

                          <th style={{ width: "150px" }}>{getPlatformName(selectProduct.PlatformType)}规格信息</th>
                          <th style={{ minWidth: "300px" }}>产品信息</th>
                          <th style={{ minWidth: "80px" }}>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          selectProduct.Skus == null || selectProduct.Skus.length == 0 ?
                            <tr><td colSpan="2">没有规格信息</td></tr> :
                            selectProduct.Skus.map((item) =>
                              $.inArray(item.SkuId, this.state.notDisplaySkuList) > -1 ?
                                null :
                                <tr>
                                  <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                                  {
                                    item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                                      <td>
                                        {
                                          item.SupplierSkuList.map((supItem, index) =>
                                            <div className='SupplierSkuList-item'>
                                              <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}>
                                                <option value="" style={{ color: "#999" }}>请选择</option>:
                                                {
                                                  this.state.supplierProductSkuList.map((item02, index02) =>
                                                    supItem.SupplierSkuId == item02.value ?
                                                      <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                                      <option value={item02.value} index={index02}>{item02.label}</option>
                                                  )
                                                }
                                              </select>
                                              <input type='number' className='SupplierSkuList-item-input' value={supItem.MappingCount} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}></input>
                                              {
                                                item.SupplierSkuList.length > 1 ?
                                                  <span className='dangerColor' onClick={(e) => this.deleteSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                                  null
                                              }
                                            </div>
                                          )
                                        }
                                      </td> :
                                      <td>
                                        <div className='SupplierSkuList-item'>
                                          <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}>
                                            <option value="">请选择</option>:
                                            {
                                              this.state.supplierProductSkuList.map((item02, index) =>
                                                item.SupplierSkuId == item02.value ?
                                                  <option value={item02.value} index={index} selected>{item02.label}</option> :
                                                  <option value={item02.value} index={index}>{item02.label}</option>
                                              )
                                            }
                                          </select>
                                          <input type='number' className='SupplierSkuList-item-input' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}></input>
                                        </div>
                                      </td>
                                  }
                                  <td><span className='smaDefBtn' onClick={(e) => this.addSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                                </tr>
                            )
                        }


                      </tbody>
                    </table>
                  </div>
                </div>

                : null
            }



          </div>
        </div>
        <div className="productMappingDailog-footer">
          <Button type="primary" style={{ width: "200px" }} onClick={() => this.sureRelevanceRequest()}>确定</Button>
        </div>
        <div className="productMappingDailog-leftClose" onClick={() => this.closeProductMapping()}>
          <i className="iconfont icon-down"></i>
        </div>


      </div>
    )

  }


  // ==========================确认采购单 遮罩弹框 end ========================


  selectSupplierProduct = (e, skuId, index) => {

    var tarEle = e.target;
    if (tarEle.value != "") {
      $(tarEle).addClass("active")
    } else {
      $(tarEle).removeClass("active")
    }

    var supplierSkuId = e.target.parentNode.childNodes[0].selectedOptions[0].value;
    var supplierSkuName = e.target.parentNode.childNodes[0].selectedOptions[0].text;
    var mappingCount = e.target.parentNode.childNodes[1].value;

    if (mappingCount != null && mappingCount != '') {
      if (!(/(^[1-9]\d*$)/.test(mappingCount))) {
        messageShow("数量必须填正整数的！", "warning");
        return false;
      }
    }

    var selectProduct = this.state.selectProduct;
    var skuList = selectProduct.Skus;
    //商品
    for (let i = 0; i < skuList.length; i++) {
      if (skuId == skuList[i].SkuId) {
        if (skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList.length == 0) {
          skuList[i].SupplierSkuList = [];
          skuList[i].SupplierSkuList.push({
            SupplierSkuId: supplierSkuId,
            SupplierSkuName: supplierSkuName,
            MappingCount: 1
          });
        }
        else {
          for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
            if (skuList[i].SupplierSkuList[n].SupplierSkuId == supplierSkuId && n != index) {
              messageShow("该供应商规格在组合中已存在！", "warning");
              e.target.selectedIndex = 0;
              skuList[i].SupplierSkuList.splice(index, 1);
              return false;
            }
          }

          skuList[i].SupplierSkuList[index].SupplierSkuId = supplierSkuId;
          skuList[i].SupplierSkuList[index].SupplierSkuName = supplierSkuName;
          skuList[i].SupplierSkuList[index].MappingCount = mappingCount;

          if (supplierSkuId == undefined || supplierSkuId == null || supplierSkuId == '') {
            messageShow("规格不能选择空，当前选择是无效的！", "warning");
            return false;
          }
        }
      }
    }
    selectProduct.Skus = skuList;
    this.setState({ selectProduct: selectProduct }, () => {
      $("#productMappingDailog .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
        if ($(item).val() != "") {
          $(item).addClass("active")
        }
      })
    })
  }

  //规格型号 添加规格
  addSupplierProductSku = (e, skuId) => {
    var selectProduct = this.state.selectProduct;
    var skuList = selectProduct.Skus;
    //商品
    for (let i = 0; i < skuList.length; i++) {
      if (skuId == skuList[i].SkuId) {
        if (skuList[i].SupplierSkuList == null) {
          skuList[i].SupplierSkuList = [];
          skuList[i].SupplierSkuList.push({
            SupplierSkuId: '',
            SupplierSkuName: '',
            MappingCount: 1
          });
        }

        skuList[i].SupplierSkuList.push({
          SupplierSkuId: '',
          SupplierSkuName: '',
          MappingCount: 1
        });
      }
    }
    selectProduct.Skus = skuList;

    this.setState({ selectProduct: selectProduct })
  }

  //规格型号 删除规格
  deleteSupplierProductSku = (e, skuId, index) => {
    var selectProduct = this.state.selectProduct;
    var skuList = selectProduct.Skus;

    for (let i = 0; i < skuList.length; i++) {
      if (skuList[i].SkuId == skuId) {
        skuList[i].SupplierSkuList.splice(index, 1);
      }
    }

    selectProduct.Skus = skuList;
    this.setState({ selectProduct: selectProduct })
  }


  //  copyPlatformOrderId=(id)=>{
  //   let ele=document.getElementById("Order"+id);
  //   app.copy(ele,function(){})
  // }


  //公共的关闭模板弹窗
  closeModal = (modalName) => {
    this.setState({
      [modalName]: false
    })
  }



  //确认关联操作，保存
  sureRelevanceRequest = () => {
    var selectProduct = this.state.selectProduct;
    var skuMappingList = [];
    var skuList = selectProduct.Skus;

    for (let i = 0; i < skuList.length; i++) {
      if (skuList[i].SupplierSkuList == undefined || skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList[0].SupplierSkuId == "") {
        continue;
      }

      for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
        if (skuList[i].SupplierSkuList[n].SupplierSkuId == undefined || skuList[i].SupplierSkuList[n].SupplierSkuId == null ||
          skuList[i].SupplierSkuList[n].SupplierSkuId == "" || skuList[i].SupplierSkuList[n].MappingCount <= 0) {
          continue;
        }

        skuMappingList.push({
          SkuId: skuList[i].SkuId,
          SupplierSkuId: skuList[i].SupplierSkuList[n].SupplierSkuId,
          MappingCount: skuList[i].SupplierSkuList[n].MappingCount
        });
      }
    }

    if (skuMappingList.length <= 0) {
      messageShow("规格不能选择空，当前选择是无效的！", "warning");
      return false;
    }

    var dataJson = {
      SupplierProductId: this.state.supplierProductId,
      SourcePlatform: this.state.selectSourcePlatform,
      SupplierMemberId: '',
      SupplierLoginId: this.state.supplierLoginId,
      ProductId: selectProduct.PlatformId,
      TargetShopId: selectProduct.ShopId,
      SkuMappings: skuMappingList,
      TargetShopPt: this.state.selectPlatformType,
    }


    var that = this;
    this.setState({ isLoading: true, loadingTitle: '保存规格中...' });
    requests({
      url: "/BatchDistribution/RelateProduct",
      data: dataJson,
      success: function (res) {
        that.setState({ isLoading: false });

        if (res.Success) {
          messageShow("映射成功！", "success");

          var productId = dataJson.ProductId;
          if (skuMappingList == null || skuMappingList == undefined)
            skuMappingList = [];

          var orderList = that.state.purchaseOrderList;
          for (let i = 0; i < orderList.length; i++) {
            var orderItemList = orderList[i].SellerOrder.OrderItems;
            for (let j = 0; j < orderItemList.length; j++) {
              if (orderItemList[j].ProductID == productId) {
                for (let k = 0; k < skuMappingList.length; k++) {
                  if (skuMappingList[k].SupplierSkuId != undefined && skuMappingList[k].SupplierSkuId != null && skuMappingList[k].SupplierSkuId != ""
                    && skuMappingList[k].SkuId == orderItemList[j].SkuID)
                    orderItemList[j].IsMapping = true;
                }
              }
            }
            orderList[i].SellerOrder.OrderItems = orderItemList;
          }

          that.setState({ purchaseOrderList: orderList });


          that.closeProductMapping();

        } else {
          messageShow("关联映射失败：" + res.Message, "error");
        }
      },
    });


  }
  //关闭状态下的子状态
  searchTradingclose = (e, refundType) => {
    this.setState({
      refundType,
      current: 1, isLoading: true
    }, () => {
      this.loadList();
    })

  }

  //子状态查询
  substateByCheckbox = (types) => {

    var isTrue = $("#" + types + "_checkboxId").is(':checked');

    var checkList = $("input[name='checkboxNameByOrderStatus']");
    for (let i = 0; i < checkList.length; i++) {
      var ck = $(checkList[i]);
      if (ck.val() == types) {
        ck.prop({ checked: isTrue });
      }
      else
        ck.prop({ checked: false });
    }

    if (!isTrue)
      types = "";

    this.setState({ isLoading: true, current: 1, refundType: "", orderSubstate: types }, () => {
      this.loadList();
    });

  }

  //清空子状态勾选
  substateCheckboxEmpty = () => {
    var checkList = $("input[name='checkboxNameByOrderStatus']");
    for (let i = 0; i < checkList.length; i++) {
      var ck = $(checkList[i]);
      ck.prop({ checked: false });
    }
  }


   //#region  折叠 支付相关的（折叠）
   
  //==============================================支付相关的==============================================================

  // 批量开启时，弹框 --关闭（不再提醒）
  batchOpenShowModalByClose = () => {
    //关闭弹框，并且后续不提醒
    this.setState({ isShowModalByBatchOpen: false, isRemindThirty: false });
  }

  // 批量开启时，弹框 --确认
  batchOpenShowModalByConfirm = () => {

    this.setState({ isRemindThirty: false, isShowModalByBatchOpen: false });
    setTimeout(() => {
      this.orderPayment();
    }, 0);

    setTimeout(() => {
      this.setState({ isRemindThirty: true });
    }, 1000);
  }




  //是否开通（自动代扣）  --请求接口
  protocalPayOpenConfirm = (isPay) => {

    this.setState({ isLoading: true, loadingTitle: '获取开通信息...' });

    var that = this;
    requests({
      url: "/PurchaseOrder/ProtocalPayOpenConfirm",
      data: {},
      success: function (res) {
        //关闭动画
        that.setState({ isLoading: false });

        if (res.Success) {
          var isOpen = res.Data;
          that.setState({ isShowModalByVerifyOpen: false });
          if (isOpen) {
            if (isPay == true)
              that.getOrderPayType();
            else
              messageShow("已开通。", "notice");
          }
          else {
            if (isPay == true)
              that.setState({ isShowModalByNotOpen: true });
            else
              messageShow("开通失败");
          }

        } else {
          messageShow("获取开通信息错误：" + res.Message, "error");
        }
      },
    });
  }

  //检测到没有开通自动代扣，弹框 --关闭
  notOpenShowModalByClose = () => {
    this.setState({ isShowModalByNotOpen: false });
  }
  //检测到没有开通自动代扣，弹框 --确认
  notOpenShowModalByConfirm = (isNotShow) => {
    //前往开通后，2秒弹出这个验证框

    var url = decodeURIComponent(this.state.openUrl);//跳转去开通代扣的链接，这个链接是开通了白名单

    window.open(url);

    this.setState({ isShowModalByNotOpen: false });
    setTimeout(() => {
      if (isNotShow == false)//是否不显示。否
        this.setState({ isShowModalByVerifyOpen: true });
    }, 2000);

  }



  //获取【支付方式】  --请求接口
  getOrderPayType = () => {
    var buyerIdList = this.state.selectPurchaseOrderList;

    var data = {
      BuyerOrderCodes: buyerIdList
    }

    this.setState({ isLoading: true, loadingTitle: '获取支付方式中...' });
    var that = this;
    requests({
      url: "/PurchaseOrder/GetOrderPayType",
      data: data,
      success: function (res) {
        //关闭动画
        that.setState({ isLoading: false });

        if (res.Success) {

          var faildOrderIds = res.Data.PayTypeQueryFaildOrderIds == undefined ? [] : res.Data.PayTypeQueryFaildOrderIds;//获取支付渠道失败的订单
          var isOpenButton = res.Data.ProtocolPayIsOpen == undefined ? false : res.Data.ProtocolPayIsOpen;//是否显示自动代付按钮
          var notWaitPayIds = res.Data.NotWaitPayIds == undefined ? [] : res.Data.NotWaitPayIds;
          var payChannels = res.Data.PayChannels == undefined ? [] : res.Data.PayChannels;//后台预留的数组。也是获取失败的。
          var paymentMoney = res.Data.PaymentMoney;//后台预留的数组。也是获取失败的。

          if (faildOrderIds.length > 0 || payChannels.length > 0 || notWaitPayIds.length > 0) {
            //获取错误列表   --提示框
            that.setState({
              getPaymentErrorFaildOrderList: faildOrderIds,
              getPaymentErrorNotWaitPayIds: notWaitPayIds,
              getPaymentErrorPayChannelsList: payChannels,
              isShowModalBySelectPaymentError: true,
            })
          } else {
            that.setState({
              isShowAutoPayButton: isOpenButton,
              isShowModalBySelectPayment: true,
              showModalByPaymentPaymentMoney: paymentMoney,
            });
          }

        } else
          messageShow("错误信息：" + res.Message, "error");
      },
    });
  }


  //选择付款方式，弹框 --手动支付
  selectPaymentShowModalByManual = () => {

    var buyerIdList = this.state.selectPurchaseOrderList;
    if (buyerIdList.length > 30) {
      messageShow("手动支付，不能超过30个订单", "notice");
      return;
    }

    this.setState({ isShowModalBySelectPayment: false });
    this.getOrderPayUrl();//获取支付链接
  }

  //选择付款方式，弹框 --自动支付
  selectPaymentShowModalByConfirm = () => {
    this.autoPaying();
  }

  //自动代扣  --请求接口
  autoPaying = () => {
    var buyerIdList = this.state.selectPurchaseOrderList;
    var data = {
      BuyerOrderCodes: buyerIdList
    }

    this.setState({ isLoading: true, loadingTitle: '正在发起自动代扣...' });
    var that = this;
    requests({
      url: "/PurchaseOrder/AutoPay",
      data: data,
      success: function (res) {

        //关闭动画
        that.setState({ isLoading: false, isShowModalBySelectPayment: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;

        if (res.Success) {
          var autoPaymentSuccessPayingOrderIds = res.Data.PayingOrderIds;
          var autoPaymentSuccessNotWaitPayIds = res.Data.NotWaitPayIds;
          var autoPaymentSuccessFaildOrderIds = res.Data.PayTypeQueryFaildOrderIds;

          if (autoPaymentSuccessPayingOrderIds.length == 0) {
            that.setState({ isShowModalByAutoPaymentError: true });
          } else {
            that.setState({
              isShowModalByAutoPaymentSuccess: true,
              autoPaymentSuccessPayingOrderIds: autoPaymentSuccessPayingOrderIds,
              autoPaymentSuccessNotWaitPayIds: autoPaymentSuccessNotWaitPayIds,
              autoPaymentSuccessFaildOrderIds: autoPaymentSuccessFaildOrderIds
            });
          }

        } else
          messageShow("错误信息：" + res.Message, "error");
      },
    });
  }

  //自动代扣失败，弹框 --关闭
  autoPaymentErrorShowModalByClose = () => {
    this.setState({ isShowModalByAutoPaymentError: false });
  }

  //自动代扣失败，弹框 --确认  --转手动支付
  autoPaymentErrorShowModalByConfirm = () => {
    var buyerIdList = this.state.selectPurchaseOrderList;
    if (buyerIdList.length > 30) {
      messageShow("手动支付，不能超过30个订单", "notice");
      return;
    }
    this.setState({ isShowModalByAutoPaymentError: false });//关闭失败的弹框

    //自动代扣失败后，可以选择手动支付
    //获取支付链接
    this.getOrderPayUrl();
  }

  //自动代扣成功，弹框 --确认 
  autoPaymentSuccessShowModalByConfirm = () => {
    this.setState({ isShowModalByAutoPaymentSuccess: false, isLoading: true });

    this.loadList();
  }




  //获取订单的【支付链接】  --请求接口
  getOrderPayUrl = () => {
    var buyerIdList = this.state.selectPurchaseOrderList;
    var data = {
      BuyerOrderCodes: buyerIdList,
      SystemVersions: 'pc'
    }

    this.setState({ isLoading: true, loadingTitle: '获取支付链接中...' });
    var that = this;
    requests({
      url: "/PurchaseOrder/getOrderPayUrl",
      data: data,
      success: function (res) {

        //关闭动画
        that.setState({ isLoading: false });

        if (res.Success) {
          var payUrl = res.Data.PayUrl;
          var faildOrderIds = res.Data.PayUrlQueryFaildOrderIds;//链接获取失败的订单
          var notSameOrderIds = res.Data.PayChannelNotSameOrderIds;//支付渠道不一致的订单
          if (faildOrderIds.length > 0 || notSameOrderIds.length > 0) {
            //获取错误列表   --提示框
            that.setState({
              getPayUrlErrorFaildOrderList: faildOrderIds,
              getPayUrlErrorPayChannelsList: notSameOrderIds,
              isShowModalByPayUrlError: true,
            })
          } else {
            var url = decodeURIComponent(payUrl);
            window.open(url);

            setTimeout(() => {
              that.setState({ isShowModalByPayUrl: true });
            }, 1000);
          }

        } else
          messageShow("错误信息：" + res.Message, "error");

      },
    });

  }


  //手动支付跳转后 弹框--确认按钮
  payUrlShowModalByConfirm = () => {
    this.setState({ isShowModalByPayUrl: false, isLoading: true });

    this.loadList();
  }

  selectPaymentShowModalByClose = () => {
    this.setState({ isShowModalBySelectPayment: false });
  }
 

  //==============================================支付相关的  end==============================================================
  //#endregion


  closeChangeProductsModule = (e) => {
    this.setState({
      isChangeProductsModule: false,changeProductsModuleAction:null,isTempRelevanceProduct:null
    })
  }
  sureChangeProductsModule = (obj) => {
    this.setState({isChangeProductsModule:false,changeProductsModuleAction:null,isTempRelevanceProduct:null})
    if(obj && obj.isOnlyOrder){
      this.UpdateSingleOrder(obj.selectProduct.PlatformId)
    }else
      this.loadList()
  }

  //relateType 1 更换货源， 2，更换规格 3，去匹配
  relevanceProduct = (item,relateType,order) => {
    if(relateType == 1){
      this.setState({
        isChangeProductsModule: true,
        selectProductId: item.ProductID,
        selectedShopProductImgSrc: item.ProductImgUrl,
        selectProductSkuId:item.SkuID,
        changeSearchNavsType:1,//图搜
        isTempRelevanceProduct:1,
        tempPlatformOrderId: order.SellerOrder.PlatformOrderId,
        tempOrderCode: order.SellerOrder.OrderCode,
        tempOrderItemCode: item.OrderItemCode,
        changeProductsModuleAction:relateType,
      })
    }else if(relateType == 2){
      this.setState({
        isChangeProductsModule: true,
        selectProductId: item.ProductID,
        selectedShopProductImgSrc: item.ProductImgUrl,
        selectProductSkuId:item.SkuID,
        changeSearchNavsType:0,//链接搜
        isTempRelevanceProduct:1,
        tempPlatformOrderId: order.SellerOrder.PlatformOrderId,
        tempOrderCode: order.SellerOrder.OrderCode,
        tempOrderItemCode: item.OrderItemCode,
        changeProductsModuleAction:relateType,
      })
    }else{
      this.setState({
        isChangeProductsModule: true,
        selectProductId: item.ProductID,
        selectedShopProductImgSrc: item.ProductImgUrl,
        selectProductSkuId:item.SkuID
      })
    }
    
  }

  relevanceProductRender = (orderItems) => {
    return (
      <table class="orderTables table-style02">
        <tr>
          <td class="orderTables-headerTd">
            <div class="orderTables-header" style={{ backgroundColor: "#f6f9fd" }}>
              <div class="orderTables-header-left">采购订单：确认后生成</div>
            </div>
          </td>
        </tr>
        {
          orderItems.filter(item => item.IsFenXiao != true).map((item, index) =>
            <tr style={{ height: '80px' }}  className={index > 1 ? "hideTr tr" + index : "tr" + index}>
              <td>
                <div className='relevanceProductWrap'>
                  <Button type="primary" onClick={() => this.relevanceProduct(item)}>
                    <i className='iconfont icon-jia-copy1'></i>
                    <span>关联货源</span>
                  </Button>
                  <div className='relevanceProductWrap-right'>
                    <span>1.暂无相关信息,请先<i className='dangerColor'>关联货源并匹配规格</i></span>
                    <span>2.<i className='dangerColor'>仅需添加一次</i>，完成后该sku的全部订单自动匹配货源sku</span>
                  </div>
                </div>
              </td>
            </tr>
          )
        }
        {
          orderItems.length > 2 ?
              <tr><td colspan="2"><div><span className="moreShowBtn" onClick={(e) => this.moreShowProduct(e, orderItems.length)}><i className="iconfont icon-down"></i><s>展开更多</s></span></div></td></tr> : null
        }
        {/* <tr>
          <td ></td>
        </tr> */}
      </table>
    )
  }

  moreBuyerListReader(item,itemBuyList,buyerOrderIndex){
    let buyerItemsLength = itemBuyList.BuyerOrder ? itemBuyList.BuyerOrder.OrderItems.length : 0;
    let sellerOrderLength = item.SellerOrder.OrderItems.filter(item => item.IsFenXiao != true).length;
    let len = buyerOrderIndex == item.BuyerOrders.length - 1 ? 
                buyerItemsLength + sellerOrderLength
                : buyerItemsLength ;
    return len > 2 ?
    (<tr><td colspan="2"><div><span className="moreShowBtn" onClick={(e) => this.moreShowProduct(e, itemBuyList.BuyerOrder.OrderItems.length )}><i className="iconfont icon-down"></i><s>展开更多</s></span></div></td></tr>) : null
  }

  /*去匹配点击事件*/
  matchSkuClick = (orderItem,order) => {
    const data ={  SupplierProductId: orderItem.SupplierProductId,SourcePlatform:orderItem.SourcePlatform} ;
    const that = this;
    orderItem.OrderCode = order.SellerOrder.OrderCode;
    that.setState({
      matchDailogShow: true,
      matchSelectedOrder: orderItem,
      selectProduct:{
        Skus:[{
          SkuId:orderItem.SkuID,
          AttributeValue1:orderItem.Color,
          AttributeValue2:orderItem.Size
        }],
        SourcePlatform:orderItem.SourcePlatform
      }
    })
    loadSupplierProduct(data).then(res =>{
      if(res.RequestError == true)
      {
        messageShow('获取供应商列表失败','error');
        return;
      }
      if(res.Success){
        var supplierProduct = res.Data.AlibabaProduct;

        var supplierProductSkuList = [];
        for (let i = 0; i < supplierProduct.Skus.length; i++) {
            var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
            var color = '';
            var size = '';

            for (let n = 0; n < attrArr.length; n++) {
                if (n == 0) {
                    color = attrArr[n].AttributeValue;
                } else {
                    size = attrArr[n].AttributeValue;
                }
            }

            supplierProductSkuList.push({
                label: color + size,
                value: supplierProduct.Skus[i].SkuId
            });
        }
        that.setState({
            matchSelectedSupplier: res.Data.AlibabaProduct,
            supplierProductSkuList:supplierProductSkuList
        });
      }
    });
  }
  //关联sku对话框关闭
  matchSkuDailogClose = ()=>{
    this.setState({
      matchDailogShow:false,
      matchSelectedOrder:null,
      matchSelectedSupplier:null,
      supplierProductSkuList:[],
      selectProduct:null
    })
  }
  /**确认保存订单中的规格 */
  confirmSaveOrderSkuMapping =()=>{
    const that = this;
    var skuMappingList = [];
    var selectProduct = this.state.selectProduct;
    var skuList = selectProduct.Skus;

    for (let i = 0; i < skuList.length; i++) {
      var item = { SkuId: skuList[i].SkuId,SupplierSkus:[] };
      skuList[i].SupplierSkuList.forEach(x => {
        item.SupplierSkus.push({ SupplierSkuId :x.SupplierSkuId, MappingCount : x.MappingCount})
      })
      skuMappingList.push(item);
    }


    var dataJson = {
      SupplierProductId: this.state.matchSelectedOrder.SupplierProductId,
      ShopId:  this.state.matchSelectedOrder.ShopId,
      SkuMappings: skuMappingList,
      SourcePlatform: selectProduct.SourcePlatform,
      OrderCode:this.state.matchSelectedOrder.OrderCode
    }
    this.setState({ isLoading: true, loadingTitle: '保存中...' });
    
    saveOrderSkuMapping(dataJson).then(res =>{
      this.setState({ isLoading: false, loadingTitle: '' });
      if(res.RequestError == true)
      {
        messageShow('服务繁忙','error');
        return;
      }
      if(res.Success == true)
      {
        this.setState({ isLoading: true});
        that.matchSkuDailogClose();
        that.loadList();
        messageShow('保存成功！','info');
      }else
      {
        messageShow(res.Message,'error');
      }
    })
  }

  //查看发货错误情况
  onlineSendErrorMsg = (platformOrderId, orderItemCode) => {

    var data = {
      ShopId: this.state.selectShopId,
      SalesOrderCode: platformOrderId,
      SalesOrderItemCode: orderItemCode
    };
    var that = this;
    that.setState({ isLoading: true });
    requests({
      url: "/PurchaseOrder/GetOnlineSendErrorMsg",
      data: data,
      success: function (res) {
        that.setState({ isLoading: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;


        if (res.Success) {
          var message = res.Data.ErrorMessage
          MessageBox.alert(message,{title:'发货失败原因'})
        } else {
          that.setState({ isLoading: false });
          messageShow("查看原因报错：" + res.Message,'error');
        }
      },
    });

  }
  /*
  *重新发货任务
  */
  reOnlineSendTask = (confirm)=>{
    var orderList = this.state.purchaseOrderList;
    var shopId = this.state.selectShopId;
    var selectShopPlatformType = this.state.selectPlatformType;

    var selectOrderList = this.state.selectOrderList;
    if(selectOrderList.length > 0)
    {
      var tempOrderList = this.state.purchaseOrderList.map(x => x.SellerOrder).filter(x => x.OrderTags);

      let findChangeAddressOrders = [];
      for (let index = 0; index < selectOrderList.length; index++) {
        const orderCode = selectOrderList[index];
        const item = tempOrderList.find(x => x.OrderCode == orderCode);
        if(!item) continue;
        
        let changeAddressTag = item.OrderTags.find(x => x.Tag == 'OrderAddressUpdate' || x.Tag == 'OrderReceiverUpdate');
        if(changeAddressTag)
          findChangeAddressOrders.push(orderCode);
      }

      if(findChangeAddressOrders.length > 0 && findChangeAddressOrders.length == selectOrderList.length && !confirm)
      {
        this.setState({ allOrderSendChangeAddressDialog:true})
        return;
      }
      else if(findChangeAddressOrders.length > 0 && !confirm)
      {
        this.setState({ orderSendChangeAddressDialog:true})
        return;
      }
      selectOrderList = selectOrderList.filter(x => !findChangeAddressOrders.includes(x))
    }

    //若未选择订单，择提示【请选择订单】
    if(selectOrderList.length == 0){
      messageShow("请先选择自动发货失败订单!",'info')
      return;
    }

    /**
     * 组装采购单、平台单数据
     */
     let purchaseOrderIds = [];
     let salesOrderCodes = [];
     let purchaseOrders = [];
     
     selectOrderList.forEach(purchaseOrderId =>{
      let order = orderList.find(o => o.SellerOrder.OrderCode == purchaseOrderId);
      if(order)
      {
        salesOrderCodes.push(order.SellerOrder.OrderCode);//平台单
        if(order.BuyerOrders && order.BuyerOrders.length > 0)
        {
          for (let index = 0; index < order.BuyerOrders.length; index++) {
            const ele= order.BuyerOrders[index];
            if(ele.BuyerOrder.PlatformOrderId)
            {
              purchaseOrderIds.push(ele.BuyerOrder.PlatformOrderId);
              purchaseOrders.push({ ShopId: ele.BuyerOrder.ShopId,PlatformOrderId:ele.BuyerOrder.PlatformOrderId})
            }
          }
        } 
      }
     })
     let apiData = {
      SalesOrderCode:salesOrderCodes,
      PurchaseOrderIds:purchaseOrderIds,
      ShopId:shopId,
      PlatformType:selectShopPlatformType,
      PurchaseOrders: purchaseOrders,
     }

     //提示加载项 【重新发货中...】
    this.setState({ isLoading: true, loadingTitle: '重新发货中...'})
    const that = this;
    
    setTimeout(() =>{
      const url = '/PurchaseOrder/ReOnlineSendTask';
      requests({
        url:url,
        data:apiData,
        success:(res) => { 
          if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          {
            that.setState({ isLoading: false });
            return;
          }

          if (res.Success) {
            const taskCode = res.Data.TaskCode;
            that.reOnlineSendTaskPoll(taskCode);
          } else{
            this.setState({ isLoading: false, loadingTitle: '重新发货中...'})
            messageShow("错误信息：" + res.Message,'error');
          }}
      });
    },0)
  }
  //轮询查询任务结果
  reOnlineSendTaskPoll(taskCode)
  {
    var that = this;
    requests({
      url: "/Common/GetZhuKeReqTask",
      data: { TaskCode: taskCode },
      success: function (res) {
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
          that.setState({ isLoading: false });
          return;
        }

        if (res.Success) {
          var dates = res.Data;
          if (dates.FinishedTime) 
          {
            that.setState({ isLoading: false});
            if (dates.Status == "Error" && dates.ErrorMsg)
                that.setState({isShowCommonError:true,showCommonErrorMessage:dates.ErrorMsg});//统一用弹窗
            else if (dates.Status == "Error" && dates.RspContent == null) {
              messageShow("任务发生了异常，失败原因:RspConten is null", 'error');
            } else {
              var rspContentJson = JSON.parse(dates.RspContent);
              let msg = rspContentJson.msg;
              messageShow( msg, 'success');
              //that.syncOneOrder("seller", "reOnlineSendButton");//同步并查询一次 
              var shopId = that.state.selectShopId;
              setTimeout(()=>{
                that.setState({ isLoading: true,purchaseOrderList:[], current: 1 }, () => {
                  that.orderListCheckboxClose();
                  that.loadList(shopId);
                })
              },3000);
              
            }
          } else {
            //任务未执行完，继续轮训
            setTimeout(() => {
              that.reOnlineSendTaskPoll(taskCode);
            }, 1000);
          }
        }
      },
    });
  }
  //订单详情页面（官方）
  // orderDetailLink = (orderId, isInspect, buyerPlatformOrderId, buyerPlatformOrderCode, sellerOrderId) => {

  //   if (isInspect == true) {
  //     var that = this;
  //     setTimeout(() => {
  //       that.setState({
  //         isShowModalByCancelExamine: true,
  //         buyerPlatformOrderId: buyerPlatformOrderId,
  //         buyerPlatformOrderCode: buyerPlatformOrderCode,
  //         detailsPlatformOrderId: sellerOrderId
  //       });
  //     }, 1000);
  //   }
  //   var url = "https://trade.1688.com/order/new_step_order_detail.htm?orderId=" + orderId;

  //   window.open(url);
  // }

  //重新发货
  reOnlineSend = (salesOrderCode,platformOrderId, purchaseOrderCode, buyerPlatformOrderId,buyerOrder) => {
    var data = {
      SalesOrderCode: salesOrderCode,
      PurchaseOrderCode: purchaseOrderCode,
      PurchaseOrderId: buyerPlatformOrderId,
      ShopId: this.state.selectShopId,
      BuyerShopId:buyerOrder.ShopId,
    }

    var orderList = this.state.purchaseOrderList.map(x => x.BuyerOrders).flat().filter(x => x && x.BuyerOrder && x.BuyerOrder.OrderTags) ;
    const item = orderList.find(x => x.BuyerOrder.OrderCode == purchaseOrderCode);
    if(item){
      let changeAddressTag = item.BuyerOrder.OrderTags.find(x => x.Tag == 'OrderAddressUpdate'  || x.Tag == 'OrderReceiverUpdate');
      if(changeAddressTag)
      {
        this.setState({ allOrderSendChangeAddressDialog:true})
        return;
      }
    }
    this.setState({ isLoading: true, loadingTitle: '重新发货...',detailsPlatformOrderId:platformOrderId});
    var that = this;
    requests({
      url: "/PurchaseOrder/ReOnlineSend",
      data: data,
      success: function (res) {
        //关闭动画
        that.setState({ isLoading: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;

        if (res.Success) {
          messageShow("重新发货成功。", 'success');
          
          that.syncOneOrder("seller", "reOnlineSendButton");//同步并查询一次
        } else
          messageShow( "错误信息：" + res.Message,'error');
      },
    });

  }


   //导出发货失败的订单
   exportSendErrorOrder = (e) => {
    //this.state.selectShopId
    this.setState({ isShowModalByExportSelet: true }, () => {
      $("input[name='exportSeletName']:eq(0)").attr("checked", 'checked');
    });
  }


  //导出，按类型来导出
  exportSendErrorOrderByType = () => {
    var types = $("input[name='exportSeletName']:checked").val();
    
      this.setState({ isLoading: true, loadingTitle: "导出中...", isShowModalByExportSelet: false });
      var that = this;
    
      requests({
        url: "/PurchaseOrder/GetSendErrorOrderExcel",
        data: { ShopId: this.state.selectShopId},
        success: function (res) {
          //关闭动画
          that.setState({ isLoading: false });
          if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
            return;
  
          if (res.Success) {
            var listData = res.Data;
            if (listData == null || listData == undefined)
              listData = [];

            if (listData.length == 0)
               messageShow( "没有查询到可导出的数据！",'error');
            else{
              if (types == "csv") {
                that.exprortExcelBySendErrorAndCsv(listData);
              }else{  //Excel导出
                that.exprortExcelBySendErrorAndExcel(listData);
              }
            }
          } else
            messageShow( "错误信息：" + res.Message,'error');
        },
      });
    
  }


  //csv格式
  exprortExcelBySendErrorAndCsv = (jsonData) => {
    //直接导出
    let str = `订单号,快递公司（必填）,快递单号,1、单次批量发货请勿超出5000条记录，如超出5000条，请拆分文件后分别上传\n`;
    str += `order_sn,shipping_name,shipping_sn,2、请不要删除第二行，否则会造成发货上传失败\n`;
    //增加\t为了不让表格显示科学计数法或者其他格式
    for (let i = 0; i < jsonData.length; i++) {
      for (let item in jsonData[i]) {
        str += `${jsonData[i][item] + '\t'},`;
      }
      str += '\n';
    }
    //encodeURIComponent解决中文乱码
    let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
    //var uri = "data:text/csv;charset=utf-8,\uFEFF" + encodeURI(str);

    //通过创建a标签实现
    var link = document.createElement("a");
    link.href = uri;
    //对下载的文件命名
    link.download = "发货失败的销售单.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  exprortExcelBySendErrorAndExcel=(listData)=>{

    const workbook = new Workbook;
    const sheet = workbook.addWorksheet('Sheet1', { properties: { defaultRowHeight: 23 } });
    sheet.pageSetup.horizontalCentered = true;
    sheet.pageSetup.verticalCentered = true;
    sheet.columns = [  //表头
      { header: '订单号', key: 'title1', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: '快递公司（必填）', key: 'title2', width: 22, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: '快递单号', key: 'title3', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: '1、单次批量发货请勿超出5000条记录，如超出5000条，请拆分文件后分别上传', key: 'title4', width: 90, style: { alignment: { vertical: 'middle', horizontal: 'left',tabColor:"#ff0000" } ,font:{color:	{ argb: 'ff511c'}} } },
    ];
    sheet.addRow({
      title1: "order_sn",
      title2:"shipping_name",
      title3: "shipping_sn",
      title4:"2、请不要删除第二行，否则会造成发货上传失败"
    });
    listData.forEach((item,index)=>{
      sheet.addRow({
        title1: item.order_sn,
        title2: item.shipping_name,
        title3: item.shipping_sn,
      });

    })
    workbook.xlsx.writeBuffer().then((buffer) => {
      undefined
      writeFile('发货失败的销售单Excel表格.xlsx', buffer);
    });
    const writeFile = (fileName, content) => {
      undefined
      let a = document.createElement("a");
      let blob = new Blob([content], { type: "text/plain" });
      a.download = fileName;
      a.href = URL.createObjectURL(blob);
      a.click();
    };

  }



  //加载订单标签
  loadOrderTags(orders,shopId)
  {
    if(!orders || orders.length == 0)
      return;

    const oiCodes = [];
    orders.forEach(order =>{
      oiCodes.push(order.SellerOrder.OrderCode);

      if(order.SellerOrder.OrderItems){
        for(const oitem of order.SellerOrder.OrderItems){
          oiCodes.push(oitem.OrderItemCode);
        }
      }
    })
    const data = {
      ShopId : shopId,
      OiCodes : oiCodes
    }
    
    OrderTagsListRequest(data).then(res =>{
      if(res.Success)
      {
        const orderTags = res.Data || [];
        var index = 0;
        orders.forEach(order =>{
          const tags = orderTags.filter(e => e.OiCode == order.SellerOrder.OrderCode);
          if(order.SellerOrder.IsShipHold == true)
          {
            tags.push({
              OiCode:order.SellerOrder.OrderCode,
              Platform:order.SellerOrder.PlatformType,
              Tag:'PddShipHold'
            });
          }
          //模拟订单标签
          // if(index == 0)
          // tags.push({
          //   OiCode:order.SellerOrder.OrderCode,
          //   Platform:order.SellerOrder.PlatformType,
          //   Tag:'OrderAddressUpdate'
          // });
          // index++;

           //抖音中转
           const touTiaoLogisticsTransitTag = tags.find(x => x.Tag == 'TouTiaoLogisticsTransitTag' );
           if(touTiaoLogisticsTransitTag)
                 order.SellerOrder.IsOrderLogisticsTransitTag=true;

          const ksAddressUpdateTag = tags.find(x => x.Tag == 'OrderAddressUpdate' ||  x.Tag == 'OrderReceiverUpdate')
          if(ksAddressUpdateTag && order.BuyerOrders && order.BuyerOrders.length > 0){
            order.BuyerOrders.filter(item => item.BuyerOrder).forEach(item => {
              if(item.BuyerOrder.PlatformStatus == 'waitsellersend' || item.BuyerOrder.PlatformStatus == 'waitbuyerpay')
              {
                item.BuyerOrder.OrderTags = [ksAddressUpdateTag];
              }
            });
          }

          order.SellerOrder.OrderTags=tags;
          
          for(const orderItem of order.SellerOrder.OrderItems){
            const orderItemTags = orderTags.filter(x => x.OiCode == orderItem.OrderItemCode)
            orderItem.tag = { };
            for(const tag of orderItemTags){
              orderItem.tag[tag.Tag] = tag;
            }
          }
        })
        this.setState({})
      }
    });

  }
  ksRiskOrderTagClickContent(order){
    const element = 
      <div class="btrigger" style={{width:"270px"}}>
        <span>该订单存在骗运费风险，48小时内平台会返回结果;</span>
        <div style={{"display":"flex","alignItems":"center"}}>
          <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
          <span>没问题，清除风控标记，正常显示收件人信息</span>
        </div>
        <div style={{"display":"flex","alignItems":"center"}}>
          <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
        <span>有问题，保留标记，并关闭订单</span>
        </div>
      </div>
    return element
  }
  pddShipHoldTagClickContent(order){
    const element = 
    <div>
      <p>该订单因发货地疫情影响，暂不支持发货，当疫情限制解除时，订单将重启承诺发货时间倒计时并支持发货</p>
      <div>
        前往拼多多后台查看订单详情
        <a href={'https://mms.pinduoduo.com/orders/detail?type=4399&sn=' + order.SellerOrder.PlatformOrderId } target="_blank">查看订单详情链接</a>
      </div>
    </div>
    return element
  }
  ksAddressUpdate(order,tag){
    const element = 
    <div>
      <div style={{fontWeight:"800",marginLeft:"16px"}}>
        <p style={{fontWeight:"800"}}>有什么影响?</p>
        <div>
          平台为避免由于下单收货人信息和实际收货信息不一致的问题带来的消费者客诉，发货前对该类订单做拦截校验。
        </div>
      </div>

      <div style={{marginTop:"24px"}}>
        <p style={{fontWeight:"800",marginLeft:"16px"}}>怎么解决?</p>
        <div>
          <div>
          
            <span><i className="dot-ZT"></i></span>【待付款】的采购单，请点击采购单右侧 <span style={{fontWeight:"800"}}>【取消订单】</span>进行关闭采购单后再重新下单
          </div>
          <div>
            <span><i className="dot-ZT"></i></span>【待发货】的采购单，请点击采购单右侧<span style={{fontWeight:"800"}}>【订单详情】</span> 进行申请采购单退款并且退款成功后再重新下单商
          </div>
          <div>
            <span><i className="dot-ZT"></i></span>【已发货】的采购单，请与供应商协商，然后点击采购单右侧<span style={{fontWeight:"800"}}>【订单详情】</span>申请采购单退款并且退款成功后再重新下单
          </div>
        </div>
      </div>
    </div>
    return element
  }
  //已取消  --关闭
  cancelExamineShowModalByClose = () => {
    this.setState({ isShowModalByCancelExamine: false });

  }

  //中转的标签提示
  orderLogisticsTransit(order,tag){
    const element = 
    <div>
      <div style={{marginTop:"24px"}}>
        <p style={{fontWeight:"800",marginLeft:"16px"}}>什么是中转订单?</p>
        <div>
          <div>
            <i className="dot-ZT"></i>平台目前推出新疆地址中转服务（后续可能会有西藏地区），商家仅需将包裹邮寄至中转仓即可，无需将包裹邮寄至消费者地址。平台在西安建立中转仓，即将新疆的物流包裹分为2段，A段：发货地--西安中转仓，B段：西安中转仓--商家收货地址。
          </div>
        </div>
      </div>

      <div style={{marginTop:"24px"}}>
        <p style={{fontWeight:"800",marginLeft:"16px"}}>有什么影响?</p>
        <div>
          <div>
            <span><i className="dot-ZT"></i></span>中转订单不支持合并下单，仅显示中转仓地址，如需查看完整地址或是物流详情，请至店铺后台查看   <a  href={'https://fxg.jinritemai.com/ffa/morder/order/detail?id='+order.SellerOrder.PlatformOrderId}  target='_blank' style={{"fontSize":"12px","color":"#0071f2"}}>订单详情</a>
          </div>
          <div>
            <span><i className="dot-ZT"></i></span>中转订单下单只能使用中转地址，请确保供应商使用抖音电子面单进行打印发货，<span style={{color:"red"}}>否则会造成买家收不到货而产生纠纷</span>
          </div>
        </div>
      </div>

      <div style={{marginTop:"24px"}}>
        <p style={{fontWeight:"800",marginLeft:"16px"}}>怎么解决?</p>
        <div>
          <div>
            <i className="dot-ZT"></i>更换货源为支持使用抖音电子面单进行打印发货的1688货源供应商
          </div>
        </div>
      </div>

    </div>
    return element
  }


  render() {

    return (
      <div className='wrap'>
        <HeaderMenu />
        <main>
          <div className='wrap-left scroll-x' >
            <NavMenu changeNav={this.changeLeftNav} defaultActive={"/orderList"} />
          </div>
          <div className="wrap-right procurementOrder">
          <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>
            {/*
              this.state.selectPlatformType == "KuaiShou" ?
                <div className='tagDanger' style={{ marginBottom: "15px", padding: '8px' }}>
                  <div>
                    <span>官方公告:延迟发货、虚假发货、虚假轨迹专项治理，请各位商家立即开展相关自査整改工作。<a className='defColor' href="https://edu.kwaixiaodian.com/rule/web/detail?id=R9DP9fGJS9" target='_blank'>了解详情</a></span>
                  </div>
                </div> : null
            */}


            <ShowNotice></ShowNotice>
            <div className='searchWrap mywrap'>
              {
                  <Select onChange={this.changeSelect.bind(this, "selectSourcePlatformSelect")} value={this.state.selectSourcePlatformSelect} clearable={true} style={{ width: "192px", marginRight: "10px" }}	>
                  {
                    this.state.sourcePlatformSelect.map((el) => {
                      return <Select.Option key={el.value} label={el.label} value={el.value} />
                    })
                  }
                </Select>
              }
              

              <Select onChange={this.changeSelect.bind(this, "selectDay")} value={this.state.selectDay} clearable={true} style={{ width: "192px", marginRight: "10px" }}	>
                {
                  this.state.daySelect.map((el) => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
              <Select onChange={this.changeSelect.bind(this, "orderBySort")} value={this.state.orderBySort} clearable={true} style={{ width: "192px", marginRight: "10px" }}	>
                <Select.Option key="asc" label="最新订单在后" value="asc" />
                <Select.Option key="desc" label="最新订单在前" value="desc" />
              </Select>
              <label>
                <input style={{ marginTop: 0 }} type="text" id="orderListInputOrderId" onChange={this.orderInputOnClick} placeholder="多个平台订单编号(，)分隔" />
              </label>
              <label style={{ marginLeft: "10px" }}>
                <input style={{ marginTop: 0 }} type="text" id="supplierWangWangInputId" placeholder="供应商旺旺" />
              </label>
              <label style={{ marginLeft: "10px" }}>
                <Select onChange={this.changeSelect.bind(this, "orderProductByType")} value={this.state.orderProductByType} clearable={true} style={{ width: "192px", marginRight: "10px" }}	>
                  <Select.Option key="ProductID" label="商品ID" value="ProductID" />
                  <Select.Option key="ProductSubject" label="商品标题" value="ProductSubject" />
                </Select>
                <input style={{ marginTop: 0 }} type="text" id="orderProductByTypeInputeId" placeholder="输入值" />
              </label>
              <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => this.queryButton(true)}>查询</Button>
            </div>

            <div className='mywrap'>
              <div className="NavChangeAndSyncOrderBtn">
                <TableNavChange distributionStatus={this.state.orderStatus} changeNav={this.changeNav} />
                <div className="progress-wrap">
                  <Progress
                    percentage={this.state.sysncOrderStatusTaskProgress}
                    type="circle"
                    width="40"
                    strokeWidth="3"
                    style={{ marginRight: "15px" }}
                  />
                  {
                    this.state.sysncOrderStatusTaskProgress == 100 || this.state.sysncOrderStatusTaskProgress == "100" ?
                      <span className="syncOrderBtn-span" onClick={() => this.syncOrder()}>同步订单</span>
                      : <span style={{ color: "#999" }}>正在同步中...</span>
                  }
                  <span className="warnColor" style={{ marginLeft: "10px" }}>上次同步时间:{this.state.lastSyncTimeByShop}</span>
                </div>
              </div>
              {/* 交易关闭的状态下，显示 */}
              <div className='searchWarn' id="searchWarn" style={{ height: "15px" }}>
                <span>店铺订单已退款但采购单：</span>
                <span onClick={(e) => this.searchTradingclose(e, "noRefund")} className={this.state.refundType == "noRefund" ? "searchBtn active" : "searchBtn"}>未申请退款</span>
                <span onClick={(e) => this.searchTradingclose(e, "refund")} className={this.state.refundType == "refund" ? "searchBtn active" : "searchBtn"}>退款中</span>

                <span className='defColor hover'>友情提示
                  <ul className='searchWarn-title'>
                    <li>1. 此功能针对开通极速退款的商家。</li>
                    <li>2. 厂家还未发货，但买家申请退款，店铺已完成极速退款；商家需及时申请采购单退款。</li>
                    <li>3. 未申请退款状态：店铺订单已完成退款，采购单已付款且未申请退款。</li>
                    <li>4. 退款中状态：店铺订单完成退款，采购单已付款且属于退款中状态。</li>
                  </ul>
                </span>
              </div>

              {/* 待发货的状态下，显示 */}
              <div className='operate-wrap' id="waitingSendExportId">
                <div className='operate-left' >
                  <label>
                    <input type="checkbox" value="sendOverdue"
                      id="sendOverdue_checkboxId"
                      name="checkboxNameByOrderStatus"
                      onClick={() => this.substateByCheckbox('sendOverdue')} />
                    <span>已逾期发货</span>
                  </label>
                  <label>
                    <input type="checkbox" value="twelveDelivery"
                      id="twelveDelivery_checkboxId"
                      name="checkboxNameByOrderStatus"
                      onClick={() => this.substateByCheckbox('twelveDelivery')} />
                    <span>12小时内需发货</span>
                  </label>
                  {/* 后台查询逻辑上，不好查，先隐藏 */}
                  {/* <label id="mergeOrderByLeftId">
                    <input type="checkbox" value="canMergeOrder"  
                     id="canMergeOrder_checkboxId"
                     name="checkboxNameByOrderStatus" 
                     onClick={()=>this.substateByCheckbox('canMergeOrder')}/>
                    <span>可合并下单</span>
                  </label> */}
                  <label id="sendErrorByLeftId" >
                    <input type="checkbox" value="autoSendError"
                      id="autoSendError_checkboxId"
                      name="checkboxNameByOrderStatus"
                      onClick={() => this.substateByCheckbox('autoSendError')} />
                    <span>自动发货失败</span>
                  </label>
                </div>
                <div className='waitingSendExportWrap' style={{ height: "23px" }} id="exportByRightId">
                  <div onClick={(e) => this.exportSendErrorOrder(e)} className={"operateBtn"}>
                    <span className="iconfont icon-xiazai"></span>
                    <span className="operateBtn-title">导出发货失败订单</span>
                  </div>
                  <span className='defColor hover'>友情提示
                    <ul className='waitingSendExport-title'>
                      <li>1. 拼多多店铺订单进行发货时，官方会检测<span style={{ color: "red" }}>是否使用了拼多多电子面单</span>获取快递单号</li>
                      <li>
                        2. 如果未使用拼多多电子面单获取单号，则会<span style={{ color: "red" }}>有几率发货失败</span>。对发货失败的订单，系统会自动重试20次。如20次还未成功，则不会自动发货，需要用户手动到拼多多店铺后台发货。
                      </li>
                      <li>
                        3. 通过工具向1688下采购单时，会<span style={{ color: "red" }}>自动备注</span>
                        【请使用拼多多电子面单发货】。但厂家是1688商家，大部分使用的是菜鸟电子面单，有条件的用户，可与厂家沟通要求使用拼多多电子面单。
                      </li>
                      <li>
                        4. 如有订单发货失败，可直接<span style={{ color: "red" }}>导出</span>发货失败订单及对应快递单号，到拼多多<span style={{ color: "red" }}>店铺后台</span>
                        使用<span style={{ color: "red" }}>表格批量导入发货</span>(<span style={{ color: "red" }}>请勿修改表格内容</span>)
                      </li>
                    </ul>
                  </span>
                </div>
              </div>

              <div className='tableWrap'>
                <table class="table-style01 orderList" id="orderList_table">
                  <thead>
                    <tr>
                      <th style={{ width: "30px" }}><input type="checkbox" id="allCheck_id_Above" onClick={() => this.allCheckbox("above")} /></th>
                      <th style={{ width: "570px" }}>平台订单信息</th>
                      <th style={{ width: "570px" }}>采购订单信息</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.isNotList == true && this.state.isAuthShop != true ?
                        <tr>
                          <td className="noneData" colSpan="20">
                            <div className="noneData-wrap">
                              <i className="iconfont icon-wushuju"></i>
                              <span className="noneData-title">暂无数据！</span>
                            </div>
                          </td>
                        </tr> : null
                    }
                    {
                      this.state.isAuthShop == true ?
                        <tr>
                          <td className="noneData" colSpan="20">
                            <div className="noneData-wrap">
                              <i className="iconfont icon-wushuju"></i>
                              <span className="noneData-title" style={{ color: "red" }}>店铺授权已失效，请前往【我的店铺】页面重新授权店铺</span>
                            </div>
                          </td>
                        </tr> : null
                    }
                    {
                      this.state.purchaseOrderList.map((item) =>
                        <tr>
                          <td>
                            <div className="inputWrap">
                              <input type="checkbox" Id={item.SellerOrder.OrderCode + "_Id"} onChange={(e) => this.orderChange(e, item.SellerOrder.OrderCode)} />
                            </div>
                          </td>
                          <td valign="top">
                            <table className="orderTables table-style02">
                              <tr>
                                <td colspan="2" className="orderTables-headerTd">
                                  <div className="orderTables-header" style={{ backgroundColor: "#fff9f0" }}>
                                    <div className="orderTables-header-left">
                                      <div className="orderTables-header-left-item">
                                        {/* <span className='iconfont icon-fuzhi1' onClick={() => this.copyPlatformOrderId(item.SellerOrder.PlatformOrderId)}></span> */}
                                        <span>订单编号：<i className="mainColor" id={"Order" + item.SellerOrder.PlatformOrderId}>{item.SellerOrder.PlatformOrderId}</i></span>
                                        <span className="mL15 orderTables-header-left-timeWrap">付款时间：<i className="mainColor">{item.SellerOrder.PayTime}</i></span>
                                      </div>
                                      <div className="orderTables-header-left-item">
                                        <span>买家昵称：<i className="mainColor">{item.SellerOrder.BuyerWangWang}</i></span>
                                        {
                                          item.SellerOrder.LastShipTimeIsRed == true && item.SellerOrder.LastShipTimeValue != "" ?
                                            <div className='lastShipTimeWrap orderTables-header-left-timeWrap'>
                                              <i className='iconfont icon-jishi' style={{ color: "#ff511c" }}></i>
                                              <span className='lastShipTimeValue' style={{ color: "#ff511c" }}>{item.SellerOrder.LastShipTimeValue}</span>
                                              {item.SellerOrder.LastShipTimeIsEnd != true ? <span>后将逾期发货</span> : null}
                                            </div>
                                            : null
                                        }
                                        {
                                          item.SellerOrder.LastShipTimeIsRed != true && item.SellerOrder.LastShipTimeValue != "" ?
                                            <div className='lastShipTimeWrap orderTables-header-left-timeWrap'>
                                              <span className='lastShipTimeValue'>{item.SellerOrder.LastShipTimeValue}</span>
                                              {item.SellerOrder.LastShipTimeIsEnd != true ? <span>后将逾期发货</span> : null}
                                            </div>
                                            : null
                                        }
                                      </div>
                                    </div>
                                    <div class="orderTables-header-right">
                                      <PlatformName platformType={item.SellerOrder.PlatformType} isHidePatformName={true} />
                                      <span class="mainColor" style={{ marginLeft: "3px" }}>{item.ShopName}</span>
                                    </div>

                                  </div>
                                </td>
                              </tr>
                              {/*平台订单-- 商品列表 */}
                              {
                                item.SellerOrder.OrderItems.map((itemSellerSkuList, index) =>
                                  this.renderSellerOrderTr(item, itemSellerSkuList, index, item.SellerOrder.OrderItems.length)
                                )
                              }
                              {

                                item.SellerOrder.OrderItems.length > 2 ?
                                  <tr><td colspan="2"><div><span className="moreShowBtn" onClick={(e) => this.moreShowProduct(e, item.SellerOrder.OrderItems.length)}><i className="iconfont icon-down-fill"></i><s>展开更多</s></span></div></td></tr> : null
                              }
                              {/*平台订单-- 地址信息 */}
                              <tr>
                                <td colspan="2">
                                  收货地址：<i class="mainColor">{item.SellerOrder.ToName}，{item.SellerOrder.ToMobile}，{item.SellerOrder.ToFullAddress}</i>
                                  {/* {
                                    item.SellerOrder.IsRisk && item.SellerOrder.IsRisk == true ?
                                      <div class="riskOrder">
                                        {
                                          item.SellerOrder.RiskShow == true ?
                                            <div class="riskOrderRemarkText">
                                              <span>该订单存在骗运费风险，48小时内平台会返回结果;</span>
                                              <div>
                                                <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
                                                <span>没问题，清除风控标记，正常显示收件人信息</span>
                                              </div>
                                              <div>
                                                <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
                                                <span>有问题，保留标记，并关闭订单</span>
                                              </div>
                                            </div> : null
                                        }
                                        <span class='smaDarBtn'
                                          onMouseOver={() => { this.setRiskShow(true, item.SellerOrder.OrderCode) }}
                                          onMouseLeave={() => { this.setRiskShow(false, item.SellerOrder.OrderCode) }} >风控订单
                                        </span>
                                      </div> : null
                                  } */}
                                  <div style={{display:"inline-block",lineHeight:"20px"}}>
                                  {
                                    item.SellerOrder.OrderTags?
                                      item.SellerOrder.OrderTags.map(tag =>{
                                        const tempTag = this.state.tagEnum[tag.Tag];
                                        if(!tempTag)
                                          return null;
                                        if(tempTag.predicate && tempTag.predicate(item,tag) == false)
                                          return null;

                                        if(!tempTag.clickContent)
                                          return <span className={tempTag.tagClass} style={{marginLeft:"4px"}}>{tempTag.tagName}</span>

                                        return <Popover placement="top" trigger="hover" width={ tempTag.width || "200px" } content={ tempTag.clickContent(item,tag) }>
                                                  <span className={tempTag.tagClass} style={{marginLeft:"4px"}}>{tempTag.tagName}</span>
                                                </Popover>
                                      }):null
                                  }
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td valign="top">
                            {/*============ 采购单============  */}
                            {
                              item.BuyerOrders == null || item.BuyerOrders.length == 0 ?
                                this.relevanceProductRender(item.SellerOrder.OrderItems)
                                :
                                item.BuyerOrders.map((itemBuyList,buyerOrderIndex) =>
                                  <table class="orderTables table-style02">
                                    <tr>
                                      <td colspan="2" class="orderTables-headerTd">
                                        <div class="orderTables-header" style={{ backgroundColor: "#f6f9fd" }}>
                                          <div class="orderTables-header-left">
                                            <div>
                                              <div className='orderTables-header-left-item'>
                                                <span style={{ display: "flex" ,alignItems: 'center' }}>
                                                  <PlatformName platformType={itemBuyList.BuyerOrder.PlatformType != null ? itemBuyList.BuyerOrder.PlatformType : 'AlibabaZhuKe'} isHidePatformName={true} />
                                                  <span style={{ marginLeft: '3px' }}>
                                                    订单号:
                                                    {itemBuyList.BuyerOrder == null || (itemBuyList.BuyerOrder != null && (itemBuyList.BuyerOrder.PlatformOrderId == ""
                                                      || itemBuyList.BuyerOrder.PlatformOrderId == null))
                                                      ? "确认后生成"
                                                      : itemBuyList.BuyerOrder.PlatformOrderId
                                                    }
                                                  </span>
                                                </span>
                                                {
                                                  itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != '' && itemBuyList.BuyerOrder.PlatformStatus != null ?
                                                    <span className="mL15">创建时间：{itemBuyList.BuyerOrder.CreateTime}</span>
                                                    : null
                                                }
                                              </div>

                                              {
                                                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.ExtField1 == "Paying" ?
                                                  <text className="defBackColor" style={{ color: "#fff" }}>免密支付中</text>
                                                  : null
                                              }
                                              {
                                                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.ExtField1 == "Faild" ?
                                                  <text className="warnBackColor" style={{ color: "#fff", backgroundColor: "#fe6f4f" }}>免密支付失败，请手动支付</text>
                                                  : null
                                              }
                                              {
                                                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.TradeType == "Alipay" && itemBuyList.BuyerOrder.ExtField1 == "Success" ?
                                                  <text className="defBackColor" style={{ color: "#fff" }}>支付宝</text>
                                                  : null
                                              }
                                              {
                                                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.TradeType == "Epay" && itemBuyList.BuyerOrder.ExtField1 == "Success" ?
                                                  <text className="defBackColor" style={{ color: "#fff" }}>诚E赊</text>
                                                  : null
                                              }
                                            </div>
                                          </div>
                                        {
                                          itemBuyList.BuyerOrder.PlatformType != "TaoteZhuKe" ?
                                          <div class="orderTables-header-right">
                                              <span>{itemBuyList.SupplierLoginId}</span>
                                              <a href={"https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=" + itemBuyList.SupplierLoginId + "&site=cnalichn"} target="_blank"> <i className="iconfont icon-wangwang"></i></a>
                                            </div>
                                          :null
                                        }
                                        {
                                          itemBuyList.BuyerOrder.PlatformType == "TaoteZhuKe" ?
                                          <div class="orderTables-header-right">
                                              <i className="iconfont icon-wangwang" onClick={()=>{ this.syncSingleOrder(itemBuyList.BuyerOrder)}}></i>
                                          </div>
                                          :null
                                        }
                                        </div>
                                    </td>
                                  </tr>
                                  {/* 采购单-商品列表 */}
                                  {
                                    itemBuyList.BuyerOrder != null ?
                                      itemBuyList.BuyerOrder.OrderItems.map((itemBuySkuList, index) =>
                                        this.renderBuyerOrderTr(itemBuyList, itemBuySkuList, index, itemBuyList.BuyerOrder.OrderItems.length, item)
                                      ) : null
                                  }
                                  {
                                    buyerOrderIndex == item.BuyerOrders.length - 1?
                                      item.SellerOrder.OrderItems.filter(item => item.IsFenXiao != true).map((item, index) =>
                                        <tr style={{ height: '80px' }} className={(itemBuyList.BuyerOrder.OrderItems.length + index + 1) > 2 ? "hideTr tr" + (itemBuyList.BuyerOrder.OrderItems.length + index + 1) : "tr" + (itemBuyList.BuyerOrder.OrderItems.length + index + 1) }>
                                          <td colspan='2'>
                                            <div className='relevanceProductWrap'>
                                              <Button type="primary" onClick={() => this.relevanceProduct(item,0)}>
                                                <i className='iconfont icon-jia-copy1'></i>
                                                <span>关联货源</span>
                                              </Button>
                                              <div className='relevanceProductWrap-right'>
                                                <span>1.暂无相关信息,请先<i className='dangerColor'>关联货源并匹配规格</i></span>
                                                <span>2.<i className='dangerColor'>仅需添加一次</i>，完成后该sku的全部订单自动匹配货源sku</span>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      ):null
                                  }
                                  
                                  {
                                    this.moreBuyerListReader(item,itemBuyList,buyerOrderIndex)
                                  }
                                  {/* {

                                    itemBuyList.BuyerOrder != null ?
                                      itemBuyList.BuyerOrder.OrderItems.length > 2 ?
                                        <tr><td colspan="2"><div><span className="moreShowBtn" onClick={(e) => this.moreShowProduct(e, itemBuyList.BuyerOrder.OrderItems.length)}><i className="iconfont icon-down"></i><s>展开更多</s></span></div></td></tr> : null : null
                                  } */}
                                  {/* 采购单 --显示物流 */}
                                  {
                                    itemBuyList.BuyerOrder != null && (itemBuyList.BuyerOrder.PlatformStatus == "waitbuyerreceive" || itemBuyList.BuyerOrder.PlatformStatus == "waitsellersend") ?
                                      <tr>
                                        <td colspan="2">
                                          <div className="expressWrap" style={{ paddingTop: 0 }}><span>物流公司:</span><span className="mainColor">{itemBuyList.LogisticsInfo.ExpressName}</span></div>
                                          <div className="expressWrap"><span>物流单号:</span><span className="mainColor">{itemBuyList.LogisticsInfo.LogisticsBillNo}</span></div>
                                          <div style={{ padding: "5px 5px 0 5px" }}><span>物流状态:</span><span className="mainColor">{itemBuyList.LogisticsInfo.TraceInfo}</span></div>
                                        </td>
                                      </tr>
                                      : null
                                  }
                                  {/* 采购单 --地址信息 */}
                                  {
                                    itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus != "" ?
                                      <tr>
                                        <td colspan="2">
                                          收货地址：<i class="mainColor">{itemBuyList.BuyerOrder.ToName}，{itemBuyList.BuyerOrder.ToMobile}，{itemBuyList.BuyerOrder.ToFullAddress}</i>
                                          {
                                            itemBuyList.BuyerOrder.IsEncryptCreateOrder == "1" ? 
                                              <Button type="warning" size="mini" style={{"borderRadius":"12px"}}>密</Button>:null
                                          }
                                          {
                                            itemBuyList.BuyerOrder.IsPifatuan? 
                                              <Button type="warning" size="mini" style={{"borderRadius":"12px"}}>精选</Button>:null
                                          }

                                          <div style={{display:"inline-block",lineHeight:"20px"}}>
                                          {
                                            item.SellerOrder.OrderTags?
                                              item.SellerOrder.OrderTags.map(tag =>{
                                                const tempTag = this.state.purchaseTagEnum[tag.Tag];
                                                if(!tempTag)
                                                  return null;
                                                if(tempTag.predicate && tempTag.predicate(item,tag) == false)
                                                  return null;

                                                if(!tempTag.clickContent)
                                                  return <span className={tempTag.tagClass} style={{marginLeft:"4px"}}>{tempTag.tagName}</span>

                                                return <Popover placement="top" trigger="hover" width={ tempTag.width || "200px" } content={ tempTag.clickContent(item,tag) }>
                                                          <span className={tempTag.tagClass} style={{marginLeft:"4px"}}>{tempTag.tagName}</span>
                                                        </Popover>
                                              }):null
                                          }
                                          </div>
                                        </td>
                                      </tr>
                                      : null
                                  }
                                  {/* 采购单 --地址信息 */}
                                  {
                                    itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.AutoCreateOrderErrorMessage != null && itemBuyList.BuyerOrder.AutoCreateOrderErrorMessage != "" ?
                                      <tr>
                                        <td colspan="2">
                                          自动下采购单失败: <i style={{ color: 'red' }}>{itemBuyList.BuyerOrder.AutoCreateOrderErrorMessage}</i>
                                        </td>
                                      </tr>
                                      : null
                                  }
                                </table>
                              )
                            }
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </table>
                <div className='paginationwrap'>
                  <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.total} pageSize={this.state.pageSize} currentPage={this.state.current} pageSizes={[10, 30, 50]} />
                </div>
              </div>

            </div>


            {/* 商品规格映射 */}
            {this.productMappingRender()}
          </div>
        </main>



        <div className="zk-footer">
          {
            this.state.orderStatusIndex == 1 && this.state.selectPurchaseOrderList.length > 30 ?
              <div className="zk-footer-wran warn-wrap">
                <i className="icon">!</i>
                <s style={{ padding: "0 5px 0 0" }}>
                  当前选择<em style={{ fontSize: "16px", color: "#ff511c" }}>{this.state.selectPurchaseOrderList.length}</em>采购单超过
                  <s style={{ fontSize: "16px", color: "#ff511c" }}>30</s>
                  笔,无法使用手动支付,建议开通自动代扣,
                </s>
                <s class="defColor hover" onClick={() => this.notOpenShowModalByConfirm(true)}>去开通》</s>
              </div>
              : null
          }

          <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below')} />
          <span>已勾选{this.state.selectOrderList.length}个订单</span>
          {
            this.state.orderStatusIndex == 0 ?
              <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => this.confirmOrder()}>批量确认</Button> : null
          }
          {
            this.state.orderStatusIndex == 1 ?
              <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => this.orderPayment()}>批量付款</Button> : null
          }
          {
            this.state.orderStatusIndex == 0 ?
              <Button style={{ marginLeft: "10px" }} type="warning" onClick={() => this.ignoreOrder(1)}>批量忽略</Button> : null
          }
          {
            this.state.orderStatusIndex == 7 ?
              <Button style={{ marginLeft: "10px" }} type="warning" onClick={() => this.ignoreOrder(0)}>取消忽略</Button> : null
          }
          {
            this.state.orderStatusIndex == 2 ?
            <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => this.reOnlineSendTask()}>重新发货</Button> : null
          }
        </div>

        {/* 提示未映射 */}
        <ShowModal showModal={this.state.isShowModalBynotCategory} titleName={"提示"} hideBtn={false}
          cancelDailog={this.cancelNotCategoryByShowModal} sureDailog={this.notCategoryByShowModalByOk}>
          <div className="showModalWrap-box-commonContent notCategory-wrap">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px 20px 0 20px", fontSize: "16px" }}>
              <i className="iconfont icon-gantan icofontStatus"></i>
              <span>有订单商品未匹配规格，前往匹配规格：</span>
            </div>
            <div className="showModalWrap-commonContent-item notCategory">
              {this.state.notCategoryListTitle}
            </div>
          </div>
        </ShowModal>


         {/* 规格映射 临时更换货源 */}
         <ShowModal skin={"RelevanceProduct"} width={"730px"} showModal={this.state.isShowTempRelevanceProduct} sureDailog={() => this.sureTempRelevanceRequest(false)} titleName={'临时更换规格'} sureBtnName={"确定"} cancelDailog={this.closeTempRelevanceProduct} >
            <div className="dailogSkuMapWrap">
                <div className="dailogSkuMapWrap-up">

                    <div className="dailogSkuMapWrap-up-title">
                        <text>已关联{getPlatformName(this.state.TempSelectPlatformTypeRelevance)}的商品</text> 
                    </div>
                    <div className="dailogSkuMapWrap-up-main">
                        <div class="productShow table-product">
                            <div class="productShow-imgWrap">
                                {
                                    this.state.TempSelectProduct != null ?
                                        <img src={this.state.TempSelectProduct.ImageUrl == null || this.state.TempSelectProduct.ImageUrl == "" ? "" : this.state.TempSelectProduct.ImageUrl} alt="" />
                                        : null
                                }

                            </div>
                            <ul>
                                <li title="商品标题">{this.state.TempSelectProduct == null ? "" : this.state.TempSelectProduct.Subject}</li>
                            </ul>
                </div>
              </div>
            </div>
            <div className="dailogSkuMapWrap-down">
              <div class="dailogSkuMapWrap-warn">临时更换商品规格，只针对当前订单商品生效。如需对当前商品所有订单及后续订单生效，请到【代销商品】中修改规格映射</div>
              <table className="table-style01">
                <thead>
                  <tr>
                    <th style={{ width: "25%" }}>{getPlatformName(this.state.TempSelectPlatformTypeRelevance)}规格信息</th>
                    <th style={{ width: "60%" }}>产品信息</th>
                    <th style={{ width: "15%" }}>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.TempSelectProduct == null || this.state.TempSelectProduct.Skus.length == 0 ?
                      <tr><td colSpan="2">没有规格信息</td></tr> :
                      this.state.TempSelectProduct.Skus.map((item, index) =>
                        <tr>
                          <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                          {
                            item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                              <td>
                                {
                                  item.SupplierSkuList.map((supItem, index) =>
                                    <div className='SupplierSkuList-item'>
                                      <select className={supItem.SupplierSkuId == '' ? 'SupplierSkuList-item-select' : 'SupplierSkuList-item-select active'} onChange={(e) => this.selectTempSupplierProduct(e, item.SkuId, index)}>
                                        <option value="">请选择</option>:
                                        {
                                          this.state.TempSupplierProductSkuList.map((item02, index02) =>
                                            supItem.SupplierSkuId == item02.value ?
                                              <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                              <option value={item02.value} index={index02}>{item02.label}</option>
                                          )
                                        }
                                      </select>
                                      <input type='number' className='SupplierSkuList-item-input' value={supItem.MappingCount} onChange={(e) => this.selectTempSupplierProduct(e, item.SkuId, index)}></input>
                                      {
                                        item.SupplierSkuList.length > 1 ?
                                          <span className='dangerColor' onClick={(e) => this.deleteTempSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                          null
                                      }
                                    </div>
                                  )
                                }
                              </td> :
                              <td>
                                <div className='SupplierSkuList-item'>
                                  <select className='SupplierSkuList-item-select' onChange={(e) => this.selectTempSupplierProduct(e, item.SkuId, 0)}>
                                    <option value="">请选择</option>:
                                    {
                                      this.state.TempSupplierProductSkuList.map((item02, index) =>
                                        item.SupplierSkuId == item02.value ?
                                          <option value={item02.value} index={index} selected>{item02.label}</option> :
                                          <option value={item02.value} index={index}>{item02.label}</option>
                                      )
                                    }
                                  </select>
                                  <input type='number' className='SupplierSkuList-item-input' onChange={(e) => this.selectTempSupplierProduct(e, item.SkuId, 0)}></input>
                                </div>
                              </td>
                          }
                          <td><span className='smaDefBtn' onClick={(e) => this.addTempSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                        </tr>
                      )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </ShowModal>


        {/* 确认采购订单，有失败的，会弹这个框  New */}
        <ShowModal showModal={this.state.isShowModalByCreateOrderError} hideBtn={true} titleName={'采购单生成错误'} >
          <div className="showModalWrap-box-commonContent orderError-wrap" style={{ padding: "15px", fontSize: "16px" }}>
            {
              this.state.createOrderError.map((item) =>

                <div className="newDialog-content-tr">
                  {/* 第一列 */}
                  <div className="newDialog-content-td">
                    {
                      item.SalesOrderIds.map((itemOrderList) =>
                        <span className="fS10">{itemOrderList}</span>
                      )
                    }
                  </div>
                  {/* 第二列 */}
                  <div className="newDialog-content-td">
                    <span className="fS10">{item.BuyerOrderId}</span>
                  </div>
                  {/* 第三列 */}
                  <div className="newDialog-content-td">
                    <span className="fS10">{item.ErrorMessage}</span>
                  </div>
                </div>

              )
            }
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.createOrderErrorShowModalByConfirm()}>确认关闭</span>
          </div>
        </ShowModal>


        {/* 批量开启时，提示 */}
        <ShowModal showModal={this.state.isShowModalByBatchOpen} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-gantan icofontStatus"></i>
              <span>批量手动付款最多只支持30笔。</span>
              <span style={{ color: "#000" }}>自动代扣不限制。</span>
            </div>
          </div>

          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.batchOpenShowModalByConfirm()}>确定</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.batchOpenShowModalByClose()}>不在提示</span>

          </div>
        </ShowModal>



        {/* 检测到没有开通自动代扣，提示 */}
        <ShowModal showModal={this.state.isShowModalByNotOpen} hideBtn={true} titleName={'提示'}>
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px 20px 0 20px", fontSize: "16px" }}>
              <i className="iconfont icon-wenhao icofontStatus"></i>
              <span>这检测到您未开通自动代扣，是否前往开通？</span>
            </div>

            <div className="showModalWrap-commonContent-item" style={{ padding: "0px 20px 10px 65px", fontSize: "16px", color: "#999" }}>
              <span>向供应商付款时只需点击按钮,无需手动支付</span>
            </div>
            <div className="showModalWrap-commonContent-item" style={{ padding: "0 20px 0 65px", fontSize: "16px", color: "#999" }}>
              <span style={{ color: "#f7941f" }}>温馨提示：可到个人中心设置开通。</span>
            </div>

          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.notOpenShowModalByConfirm()}>前往开通</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.notOpenShowModalByClose()}>关闭</span>
          </div>
        </ShowModal>


        {/* 选择付款方式，提示 */}
        <ShowModal showModal={this.state.isShowModalBySelectPayment} hideBtn={true} titleName={'待付款金额' + this.state.showModalByPaymentPaymentMoney + '元'} >
          <div className="showModalWrap-box-commonContent">
            {
              this.state.isShowAutoPayButton == true ?
                <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
                  <i className="iconfont icon-gantan icofontStatus"></i>
                  <span>免密支付优先使用诚e赊代扣,若失败则使用支付宝代扣</span>
                </div>
                :
                <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
                  <i className="iconfont icon-wenhao icofontStatus"></i>
                  <span>是否使用手动支付？</span>
                </div>
            }
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" style={{ marginLeft: "5px" }} onClick={() => this.selectPaymentShowModalByManual()}>手动支付</span>
            {
              this.state.isShowAutoPayButton == true ?
                <span className="showModalWrap-box-footer-btn" style={{ marginLeft: "5px" }} onClick={() => this.selectPaymentShowModalByConfirm()}>免密支付</span>
                : null
            }
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.selectPaymentShowModalByClose()}>关闭</span>
          </div>
        </ShowModal>


        {/* 获取支付链接（手动支付的方式），有错误的 提示弹框，提示 */}
        <ShowModal showModal={this.state.isShowModalByPayUrlError} hideBtn={true} titleName={'手动支付链接失败'} >
          <div className="showModalWrap-box-commonContent paymentErrorWrap">
            <div className="paymentErrorWrap-table">
              <div className="paymentErrorWrap-table-tr" style={{ color: "#04385d" }}>
                <span className="paymentErrorWrap-table-td">订单编号</span>
                <span className="paymentErrorWrap-table-td">错误类型</span>
              </div>
              {
                this.state.getPayUrlErrorFaildOrderList.map((item) =>
                  <div className="paymentErrorWrap-table-tr">
                    <span className="paymentErrorWrap-table-td">{item}</span>
                    <span className="paymentErrorWrap-table-td">支付渠道失败</span>
                  </div>
                )
              }
              {
                this.state.getPayUrlErrorPayChannelsList.map((item) =>
                  <div className="paymentErrorWrap-table-tr">
                    <span className="paymentErrorWrap-table-td">{item}</span>
                    <span className="paymentErrorWrap-table-td">支付渠道不一致</span>
                  </div>
                )
              }
            </div>
            <div className="showModalWrap-box-commonfooter">
              <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowModalByPayUrlError")}>关闭</span>
            </div>
          </div>
        </ShowModal>

        {/* 获取支付链接（手动支付的方式），有错误的 提示弹框，提示 */}
        <ShowModal showModal={this.state.isShowModalByPayUrl} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-gantan icofontStatus"></i>
              <span>是否已手动支付成功？</span>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.payUrlShowModalByConfirm()}>已支付并刷新</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowModalByPayUrl")}>关闭</span>
          </div>
        </ShowModal>

        {/* 自动代扣失败，提示 */}
        <ShowModal showModal={this.state.isShowModalByAutoPaymentError} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-add-fill-hover-copy icofontStatus"></i>
              <span>自动代扣失败，请使用手动支付</span>
            </div>

          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.autoPaymentErrorShowModalByConfirm()}>手动支付</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.autoPaymentErrorShowModalByClose()}>关闭</span>
          </div>
        </ShowModal>


        {/* 自动代扣成功，提示 */}
        <ShowModal showModal={this.state.isShowModalByAutoPaymentSuccess} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px 20px 0 20px", fontSize: "16px" }}>
              <span>已对{this.state.autoPaymentSuccessPayingOrderIds.length}笔采购单发起免密支付</span>
            </div>
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px 20px 0 20px", fontSize: "16px" }}>
              {this.state.autoPaymentSuccessNotWaitPayIds.length > 0 ? <span>有{this.state.autoPaymentSuccessNotWaitPayIds.length}个订单不属于待付款！</span> : null}
              {this.state.autoPaymentSuccessFaildOrderIds.length > 0 ? <span>有{this.state.autoPaymentSuccessFaildOrderIds.length}个订单发起失败！</span> : null}
              <span> 请耐心等待支付结果</span>
            </div>
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <span style={{ color: "#f7941f" }}>温馨提示：可到个人中心设置开通。</span>
            </div>
          </div>

          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.autoPaymentSuccessShowModalByConfirm()}>关闭</span>
          </div>
        </ShowModal>


        {/* 统一的错误弹窗 */}
        <ShowModal width={"500px"} showModal={this.state.isShowCommonError} hideBtn={true} >
          <div className="showModalWrap-box-commonContent" style={{ fontSize: "16px", padding: "10px" }}>
            <div style={{ paddingLeft: "16px", marginBottom: "10px", marginTop: "10px" }}>
              {this.state.showCommonErrorMessage}
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowCommonError")}>关闭</span>
          </div>
        </ShowModal>

        <ShowModal width={"540px"} showModal={this.state.encryFialdDialog} hideBtn={true} titleName={'确认'} >
          <div className="showModalWrap-box-commonContent" style={{ "fontSize": "14px", "marginLeft": "30px", "marginTop": "10px" }}>
            <div>
              {/* 订单{ this.state.encryFaildPlatformOrderId }, */}
              解密失败：{this.state.encryErrorMessage}
            </div>
            <p></p>
            <div>
              <span>订单密文下单，不消耗店铺解密额度。</span>
              <a href="https://docs.qq.com/doc/DYkFjV3R2TFZKUnZn" target="_blank" style={{ "fontSize": "12px" ,"color":"#0071f2"}}> 点击了解详情</a>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => { this.props.history.push("/supplierMarke") }}>去打标</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeModal("encryFialdDialog") }}>关闭</span>
          </div>
        </ShowModal>


        <ShowModal width={"540px"} showModal={this.state.encryFialdDialogByZhongZhuan} hideBtn={true} titleName={'确认'} >
          <div className="showModalWrap-box-commonContent" style={{ "fontSize": "14px", "marginLeft": "30px", "marginTop": "10px" }}>
          <div>
            检测到当前中转订单未使用密文下单。<span style={{"color":"red"}}>由于中转订单下单只能使用中转地址，供应商必须使用抖音电子面单进行打印，否则会造成买家收不到货而产生纠纷。</span>
            </div>
            <div>
            如确认供应商已支持使用抖音电子面单进行打印，请前往【订单管理】》【下单设置】中对供应商进行标记使用密文下单 
            </div>
            <div>
              <a href="https://docs.qq.com/doc/DYkFjV3R2TFZKUnZn" target="_blank" style={{"fontSize":"12px","color":"#0071f2"}}> 点击了解密文详情</a>
            </div>  
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => { this.props.history.push("/supplierMarke") }}>去打标</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeModal("encryFialdDialogByZhongZhuan") }}>关闭</span>
          </div>
        </ShowModal>

		{/* 商品规格映射 */}
      <ShowModal  width={"900px"} titleName={"商品规格映射"} showModal={this.state.matchDailogShow} hideBtn={true}>
          <div className="showModalWrap-box-commonContent" style={{ maxHeight: '460px' }}>
              <div>
                  <div className='second-SkuMapWrap-top'>    
                      <div className="dailogSkuMapWrap-up">
                          {
                            <div>
                                <div className="dailogSkuMapWrap-up-title">
                                    {/* {this.state.selectPlatformTypeRelevance == "KuaiShou" ? <span>已关联快手的商品</span> : null}
                                    {this.state.selectPlatformTypeRelevance == "TouTiao" ? <span>已关联头条的商品</span> : null}
                                    {this.state.selectPlatformTypeRelevance == "Taobao" ? <span>已关联淘宝的商品</span> : null}
                                    {this.state.selectPlatformTypeRelevance == "Pinduoduo" ? <span>已关联拼多多的商品</span> : null} */}
                                    <span>已关联{getPlatformName(this.state.selectPlatformTypeRelevance)}的商品</span>
                                </div>
                                <div className="dailogSkuMapWrap-up-main">
                                    <div class="productShow table-product">
                                        <div class="productShow-imgWrap">
                                            {
                                                this.state.matchSelectedOrder != null ?
                                                    <img src={this.state.matchSelectedOrder.ProductImgUrl == null || this.state.matchSelectedOrder.ProductImgUrl == "" ? "" : this.state.matchSelectedOrder.ProductImgUrl} alt="" />
                                                    : null
                                            }

                                        </div>
                                        <ul>
                                            <li title="商品标题">{this.state.matchSelectedOrder == null ? "" : this.state.matchSelectedOrder.ProductSubject}</li>
                                            <li className='dangerColor'>售价：￥{this.state.matchSelectedOrder == null || this.state.matchSelectedOrder.ItemAmount == null ? "" : this.state.matchSelectedOrder.ItemAmount}起</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                          }                                                                      
                      </div>
                      <div className='dailogSkuMapWrap-mid'>
                          <span>对应货源</span>
                          <i className='iconfont icon-fanhuidingbu'></i>
                      </div>                
                      <div className="dailogSkuMapWrap-up">
                          <div className="dailogSkuMapWrap-up-title">
                              <span>已关联1688的商品</span>
                          </div>
                          <div className="dailogSkuMapWrap-up-main">
                              <div class="productShow table-product">
                                  <div class="productShow-imgWrap">
                                      {
                                          this.state.matchSelectedSupplier != null ?
                                              <img src={this.state.matchSelectedSupplier.PicURI == null || this.state.matchSelectedSupplier.PicURI == "" ? "" : this.state.matchSelectedSupplier.PicURI} alt="" />
                                              : null
                                      }
                                  </div>
                                  <ul>
                                      <li title="商品标题">{this.state.matchSelectedSupplier == null ? "" : this.state.matchSelectedSupplier.Subject}</li>
                                      <li className='dangerColor'>进货价：￥{this.state.matchSelectedSupplier == null || this.state.matchSelectedSupplier.ReferencePrice == null ? "" : this.state.matchSelectedSupplier.ReferencePrice}起</li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="dailogSkuMapWrap-down">
                      <table className="table-style01" style={{width:'870px'}}>
                          <thead>
                              <tr>
                                  <th style={{ width: "350px" }}>店铺商品规格信息</th>
                                  <th style={{ width: "410px" }}>待采购规格信息</th>
                                  <th style={{ width: "90px" }}>操作</th>
                              </tr>
                          </thead>
                          <tbody>
                              {
                                  this.state.selectProduct == null || this.state.selectProduct.Skus.length == 0 ?
                                  <tr><td colSpan="2">没有规格信息</td></tr> :
                                  this.state.selectProduct.Skus.map((item, index) =>
                                      <tr>
                                          <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                                          {
                                              item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                                                  <td>
                                                      {
                                                          item.SupplierSkuList.map((supItem, index) =>
                                                              <div className='SupplierSkuList-item'>
                                                                  <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}>
                                                                      <option value="">请选择</option>:
                                                                      {
                                                                          this.state.supplierProductSkuList.map((item02, index02) =>
                                                                              supItem.SupplierSkuId == item02.value ?
                                                                                  <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                                                                  <option value={item02.value} index={index02}>{item02.label}</option>
                                                                          )
                                                                      }
                                                                  </select>
                                                                  <input type='number' value={supItem.MappingCount} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}></input>
                                                                  {
                                                                      item.SupplierSkuList.length > 1 ?
                                                                          <span className='dangerColor' onClick={(e) => this.deleteSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                                                          null
                                                                  }
                                                              </div>
                                                          )
                                                      }
                                                  </td> :
                                                  <td>
                                                      <div className='SupplierSkuList-item'>
                                                          <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}>
                                                              <option value="">请选择</option>:
                                                              {
                                                                  this.state.supplierProductSkuList.map((item02, index) =>
                                                                      item.SupplierSkuId == item02.value ?
                                                                          <option value={item02.value} index={index} selected>{item02.label}</option> :
                                                                          <option value={item02.value} index={index}>{item02.label}</option>
                                                                  )
                                                              }
                                                          </select>
                                                          <input type='number' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}></input>
                                                      </div>
                                                  </td>
                                          }
                                          <td><span className='smaDefBtn' onClick={(e) => this.addSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                                      </tr>
                                  )
                              }
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
              <span onClick={() => this.confirmSaveOrderSkuMapping()} className="showModalWrap-box-footer-btn">确定关联</span>
              <span onClick={() => this.matchSkuDailogClose()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
          </div>
      </ShowModal>
        {/* 付款二维码*/}
        <Dialog
          size="tiny"
          visible={this.state.payModel.qrcodeShow}
          onCancel={() => { this.closeQrCodeInfo() }}
          lockScroll={false}
          closeOnClickModal={false}
          closeOnPressEscape={false}
          style={{width:"350px"}}
          customClass="authorizationDialogWrap"
          className="taoteDailog"
        >
          <Dialog.Body>
            <div className='qrcodewarp'>
              <div>
                <h4>使用手机版淘特APP扫码付款</h4>
              </div>
              <div>
                {
                  this.state.payModel.PayUrl ?
                  <div style={{"marginLeft":"10px"}}> 
                    <QRCode
                        id="bill_qr_code_url"
                        value={this.state.payModel.PayUrl} //value参数为生成二维码的链接 我这里是由后端返回
                        size={200} //二维码的宽高尺寸
                        fgColor="#000000"  //二维码的颜色
                    />
                  </div>: null
                  // <div className={ this.state.taoteAuthInfo.refreshQRCode ?'refresQrCode active':'refresQrCode'}>
                  //   <i className={'iconfont icon-tongbu'} onClick={()=>{ this.taoteGenerateQRCode() }} style={{"fontSize":"50px"}}></i>
                  // </div>
                }
                <div>二维码过期时间倒计时： { 
                  this.state.payModel.timespan == 0 ?
                  <span style={{"color":"red"}}>已过期</span>:
                  <span><span id='authTimespan'></span>秒</span>
                }</div>
              </div>
            </div>
            <div className='hint'>
              提示:若出现未找到订单的情况，可能是因为当前扫码账号和绑定的采购账号不一致，请登录采购账号后再扫码。
            </div>
          </Dialog.Body>
        </Dialog>

        <ChangeProductsModule
          productTag={this.state.productTag}
          selectProductId={this.state.selectProductId}
          selectProductSkuId={this.state.selectProductSkuId}
          selectedShopProductImgSrc={this.state.selectedShopProductImgSrc}
          title="关联货源"
          showModal={this.state.isChangeProductsModule}
          activeSearchNavId={this.state.changeSearchNavsType}
          isTempRelevanceProduct={this.state.isTempRelevanceProduct}
          tempPlatformOrderId={this.state.tempPlatformOrderId}
          tempOrderCode={this.state.tempOrderCode}
          tempOrderItemCode={this.state.tempOrderItemCode}
          changeProductsModuleAction ={this.state.changeProductsModuleAction}
          closeChangeProductsModule={this.closeChangeProductsModule}
          sureRelevanceRequest={this.sureChangeProductsModule}
        />




      <ShowModal width={"520px"} showModal={this.state.orderPayChangeAddressDialog} hideBtn={true} showRightTopBtn={true} cancelDailog={() => this.closeModal("orderPayChangeAddressDialog")}>
            <div className="showModalWrap-box-commonContent" style={{ fontSize: "14px", padding: "10px",lineHeight:"26px"}}>
                <div style={{ paddingLeft: "16px", marginBottom: "10px"}}>

                    {
                      getLoginShopInfo().loginShopPlatformType == "TouTiao"?
                      <div>
                        <div>因抖音平台要求</div>
                        <div>发货使用的买家电话、地址信息必须与订单实际最新电话、地址信息一致</div>
                        <div>系统识别到您选择的订单中包含收件人信息已变更订单</div>
                        <div>请手动关闭对应的采购单后使用最新地址重新下单</div>
                      </div>:
                      <div>
                        <div>因快手平台要求</div>
                        <div>发货使用的买家地址信息必须与订单实际最新地址信息一致</div>
                        <div>系统识别到您选择的订单中包含买家已变更地址订单</div>
                        <div>请手动关闭对应的采购单后使用最新地址重新下单</div>
                      </div>
                    }
                    
                </div>
            </div>
            <div className="showModalWrap-box-commonfooter">
                <span className="showModalWrap-box-footer-btn" onClick={() => { this.orderPayment(null,true);this.closeModal("orderPayChangeAddressDialog")}}>忽路此订单，先付款其他订单</span>
            </div>
        </ShowModal>

        <ShowModal width={"520px"} showModal={this.state.allOrderPayChangeAddressDialog} hideBtn={true} showRightTopBtn={true} cancelDailog={() => this.closeModal("allOrderPayChangeAddressDialog")}>
            <div className="showModalWrap-box-commonContent" style={{ fontSize: "14px", padding: "10px",lineHeight:"26px"}}>
                <div style={{ paddingLeft: "16px", marginBottom: "10px"}}>
                  {
                     getLoginShopInfo().loginShopPlatformType == "TouTiao"?
                     <div>
                        <div>因抖音平台要求</div>
                        <div>发货使用的买家电话、地址信息必须与订单实际最新电话、地址信息一致</div>
                        <div>系统识别到您选择的订单中包含收件人信息已变更订单</div>
                        <div>请点击采购单右侧<span style={{fontWeight:"800"}}>【取消订单】</span>进行关闭采购单后再重新下单</div>
                     </div>:
                     <div>
                        <div>快手平台要求</div>
                        <div>发货使用的买家地址信息必须与订单实际最新地址信息一致</div>
                        <div>系统识别到您选择的订单中包含买家已变更地址订单</div>
                        <div>请点击采购单右侧<span style={{fontWeight:"800"}}>【取消订单】</span>进行关闭采购单后再重新下单</div>
                      </div>
                  }
                  
                </div>
            </div>
            <div className="showModalWrap-box-commonfooter">
                <span className="showModalWrap-box-footer-btn" onClick={() => this.closeModal("allOrderPayChangeAddressDialog")}>我知道了</span>
            </div>
        </ShowModal>

        <ShowModal width={"520px"} showModal={this.state.orderSendChangeAddressDialog} hideBtn={true} showRightTopBtn={true} cancelDailog={() => this.closeModal("orderSendChangeAddressDialog")}>
            <div className="showModalWrap-box-commonContent" style={{ fontSize: "14px", padding: "10px",lineHeight:"26px"}}>
                <div style={{ paddingLeft: "16px", marginBottom: "10px"}}>
                  {
                    getLoginShopInfo().loginShopPlatformType == "TouTiao"?
                    <div>
                      <div>因抖音平台要求</div>
                      <div>发货使用的买家电话、地址信息必须与订单实际最新电话、地址信息一致</div>
                      <div>系统识别到您选择的订单中包含收件人信息已变更订单</div>
                      <div>请点击采购单右侧<span style={{fontWeight:"800"}}>【取消订单】</span>进行申请采购单退款并且退款成功后再重新下单</div>
                    </div>:
                    <div>
                      <div>因快手平台要求</div>
                      <div>发货使用的买家地址信息必须与订单实际最新地址信息一致</div>
                      <div>系统识别到您选择的订单中包含买家已变更地址订单</div>
                      <div>请点击采购单右侧<span style={{fontWeight:"800"}}>【取消订单】</span>进行申请采购单退款并且退款成功后再重新下单</div>
                    </div>
                  }
                </div>
            </div>
            <div className="showModalWrap-box-commonfooter">
                <span className="showModalWrap-box-footer-btn" onClick={() => { this.closeModal("orderSendChangeAddressDialog");this.reOnlineSendTask(true) }}>忽路此订单，先发货其他订单</span>
            </div>
        </ShowModal>

        <ShowModal width={550} showModal={this.state.isShowModalByExportSelet} hideBtn={true} titleName={'请选择导出格式'} >
          <div className="showModalWrap-box-commonContent" style={{ padding: "20px" }}>
            <div className="showModalWrap-commonContent-item" style={{ marginBottom: "20px" }}>
              <label style={{ marginRight: "50px" }}>
                <input type="radio" name='exportSeletName' value="csv" style={{ marginRight: "3px" }} />CSV
              </label>
              {/* 店铺版本还需要修复Excel，才可以放开 */}
              <label>
                <input type="radio" name='exportSeletName' value="excel" style={{ marginRight: "3px" }} />Excel
              </label>
            </div>

            <div className="showModalWrap-commonContent-item" style={{ lineHeight: "22px" }}>
              <span>温馨提示：选择CSV格式导出后，<span style={{ color: "red" }}>请勿编辑</span>改格式的内容。可直接到平台店铺的后台<span style={{ color: "red" }}>批量导入发货</span></span>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.exportSendErrorOrderByType()}>确定导出</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowModalByExportSelet")}>关闭</span>
          </div>
        </ShowModal>

        <ShowModal width={"520px"} showModal={this.state.allOrderSendChangeAddressDialog} hideBtn={true} showRightTopBtn={true} cancelDailog={() => this.closeModal("allOrderSendChangeAddressDialog")}>
            <div className="showModalWrap-box-commonContent" style={{ fontSize: "14px", padding: "10px",lineHeight:"26px"}}>
                <div style={{ paddingLeft: "16px", marginBottom: "10px"}}>
                  {
                    getLoginShopInfo().loginShopPlatformType == "TouTiao"?
                    <div>
                      <div>因抖音平台要求</div>
                      <div>发货使用的买家电话、地址信息必须与订单实际最新电话、地址信息一致</div>
                      <div>系统识别到您选择的订单中包含收件人信息已变更订单</div>
                      <div>请点击采购单右侧<span style={{fontWeight:"800"}}>【取消订单】</span>进行申请采购单退款并且退款成功后再重新下单</div>
                    </div>:
                    <div>
                      <div>因快手平台要求</div>
                      <div>发货使用的买家地址信息必须与订单实际最新地址信息一致</div>
                      <div>系统识别到您选择的订单中包含买家已变更地址订单</div>
                      <div>请点击采购单右侧<span style={{fontWeight:"800"}}>【取消订单】</span>进行申请采购单退款并且退款成功后再重新下单</div>
                    </div>
                  }
                </div>
            </div>
            <div className="showModalWrap-box-commonfooter">
                <span className="showModalWrap-box-footer-btn" onClick={() => this.closeModal("allOrderSendChangeAddressDialog")}>我知道了</span>
            </div>
        </ShowModal>
        {/* 取消订单，点击后一秒弹出 */}
        <ShowModal showModal={this.state.isShowModalByCancelExamine} hideBtn={true} titleName={'提示'}>
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-wenhao icofontStatus"></i>
              <span>是否已成功取消了订单？</span>
            </div>

          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.cancelExamineShowModalByConfirm()}>已取消并刷新</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelExamineShowModalByClose()}>关闭</span>
          </div>
        </ShowModal>

        <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} title={this.state.loadingTitle}/>
        <NewUserGuide></NewUserGuide>
      </div>

    )
  }
}

export default procurementOrder;


// WEBPACK FOOTER //
// ./src/pages/procurementOrder/procurementOrder.jsx